"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3843],{

/***/ 3843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _pid_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Box/index.js
var Box = __webpack_require__(18636);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Container/index.js
var Container = __webpack_require__(15665);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
// EXTERNAL MODULE: ./src/hooks/useIsFirstRender.ts
var useIsFirstRender = __webpack_require__(82569);
// EXTERNAL MODULE: ./src/reducers/ProductPageReducer.ts
var ProductPageReducer = __webpack_require__(83574);
// EXTERNAL MODULE: ./src/reducers/CardCustomisationReducer.ts
var CardCustomisationReducer = __webpack_require__(50252);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/components/pages/store/ProductSchemaMarkup.tsx


var ProductSchemaMarkup = function(param) {
    var sku = param.sku;
    var getThemeImage = function getThemeImage(sku) {
        var ref, ref1;
        return sku.themes.length > 0 ? (ref = sku.themes) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.image : "";
    };
    var makeJsonLd = function makeJsonLd(sku) {
        var priceList = sku.denominations.sort(function(d1, d2) {
            return d1.value > d2.value ? 1 : 0;
        });
        var image = getThemeImage(sku);
        var lowPrice = priceList.length > 0 ? priceList[0].price : 0;
        var highPrice = priceList.length > 0 ? priceList[priceList.length - 1].price : 0;
        var currency = priceList.length > 0 ? priceList[0].priceCurrency : "AUD";
        return {
            "@context": "https://schema.org/",
            "@type": "Product",
            name: sku.displayName,
            image: [
                image
            ],
            description: sku.description,
            sku: sku.name,
            brand: {
                "@type": "Brand",
                name: sku.name
            },
            offers: {
                "@type": "AggregateOffer",
                lowPrice: lowPrice.toString(),
                highPrice: highPrice.toString(),
                priceCurrency: currency,
                availability: "https://schema.org/InStock",
                itemCondition: "https://schema.org/NewCondition"
            }
        };
    };
    var jsonLd = JSON.stringify(makeJsonLd(sku));
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((script_default()), {
        async: true,
        id: "productSchemaMarkeup",
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: jsonLd
        }
    });
};

// EXTERNAL MODULE: ./src/contexts/ProductPageContext.tsx
var ProductPageContext = __webpack_require__(16029);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Typography/index.js
var Typography = __webpack_require__(43543);
// EXTERNAL MODULE: ./node_modules/@prezzee/alert/lib/index.js
var lib = __webpack_require__(33722);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Stack/index.js
var Stack = __webpack_require__(72406);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Button/index.js
var Button = __webpack_require__(43515);
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 127 modules
var react_markdown = __webpack_require__(31758);
// EXTERNAL MODULE: ./node_modules/@emotion/css/dist/emotion-css.esm.js
var emotion_css_esm = __webpack_require__(97133);
// EXTERNAL MODULE: ./node_modules/@prezzee/tokens/lib/index.js
var tokens_lib = __webpack_require__(53126);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/hooks/useDisclosure.js
var useDisclosure = __webpack_require__(18500);
// EXTERNAL MODULE: ./src/components/CmsImage.tsx
var CmsImage = __webpack_require__(73450);
;// CONCATENATED MODULE: ./src/components/pages/store/CardDisplayImage.tsx





var Styles = {
    card: function(zagBanner) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:100%;box-shadow:", tokens_lib.shadows.md, ";border-radius:10px;margin-bottom:", tokens_lib.spacing.spacing02, ";& > img{margin:0;border-radius:", zagBanner ? "10px 10px 0 0" : "10px", ";width:100%;}");
    }
};
var CardDisplayImage = function() {
    var ref = (0,ProductPageContext/* useProduct */.i)(), sku = ref.sku, cardCustomisationState = ref.cardCustomisationState, userUploadedDesignFileInput = ref.userUploadedDesignFileInput, isLayer = ref.isLayer;
    var src = "";
    var renderAsTemplate = false;
    if (!cardCustomisationState) return null;
    var customCardDesignIsEnabled = cardCustomisationState.customCardDesignIsEnabled, initialCardDesign = cardCustomisationState.initialCardDesign, selectedCardDesign = cardCustomisationState.selectedCardDesign, customThemeDesigns = cardCustomisationState.customThemeDesigns;
    if (!customCardDesignIsEnabled) {
        src = (initialCardDesign === null || initialCardDesign === void 0 ? void 0 : initialCardDesign.imageUrl) || "";
    } else {
        if (selectedCardDesign) {
            var imageUrl = selectedCardDesign.imageUrl, isTemplate = selectedCardDesign.isTemplate, uid = selectedCardDesign.uid;
            renderAsTemplate = isTemplate;
            if (isTemplate && (customThemeDesigns === null || customThemeDesigns === void 0 ? void 0 : customThemeDesigns.length)) {
                var customThemeDesign = customThemeDesigns.find(function(t) {
                    return t.templateUid === uid;
                });
                src = (customThemeDesign === null || customThemeDesign === void 0 ? void 0 : customThemeDesign.image) || imageUrl;
            } else {
                src = imageUrl;
            }
        } else if (initialCardDesign) {
            var imageUrl1 = initialCardDesign.imageUrl, isTemplate1 = initialCardDesign.isTemplate;
            renderAsTemplate = isTemplate1;
            src = imageUrl1;
        }
    }
    var handleClick = function(ev) {
        ev.preventDefault();
        if (renderAsTemplate && (userUploadedDesignFileInput === null || userUploadedDesignFileInput === void 0 ? void 0 : userUploadedDesignFileInput.current)) {
            userUploadedDesignFileInput.current.click();
        }
    };
    var Element = renderAsTemplate ? "button" : "div";
    var desktopSm = "(max-width: 1124px)";
    var tabletLg = "(max-width: 990px)";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Element, {
        title: renderAsTemplate ? "Tap to add your own image" : undefined,
        "aria-label": renderAsTemplate ? "Tap to add your own image" : undefined,
        onClick: handleClick,
        className: Styles.card(false),
        children: src && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
            src: src,
            alt: sku.displayName + " gift card image",
            width: 452,
            height: 280,
            sizes: "".concat(tabletLg, " 100vw, ").concat(desktopSm, " 39vw, 393px"),
            priority: true
        })
    });
};
/* harmony default export */ var store_CardDisplayImage = (CardDisplayImage);

// EXTERNAL MODULE: ./src/components/pages/store/RetailerListModal.tsx
var RetailerListModal = __webpack_require__(99725);
// EXTERNAL MODULE: ./src/utils/debounce.ts
var debounce = __webpack_require__(60752);
;// CONCATENATED MODULE: ./src/components/common/ClampLines.tsx





var ClampLinesProps = function(param) {
    var textProp = param.text, id = param.id, _lines = param.lines, lines = _lines === void 0 ? 3 : _lines, _ellipsis = param.ellipsis, ellipsis = _ellipsis === void 0 ? "..." : _ellipsis, _buttons = param.buttons, buttons = _buttons === void 0 ? true : _buttons, _moreText = param.moreText, moreText = _moreText === void 0 ? "Read more" : _moreText, _lessText = param.lessText, lessText = _lessText === void 0 ? "Read less" : _lessText, classNameProp = param.className, _delay = param.delay, delay = _delay === void 0 ? 300 : _delay, stopPropagationProp = param.stopPropagation, _innerElement = param.innerElement, innerElement = _innerElement === void 0 ? "div" : _innerElement;
    var ref = (0,react.useState)(true), expanded = ref[0], setExpanded = ref[1];
    var ref1 = (0,react.useState)(false), noClamp = ref1[0], setNoClamp = ref1[1];
    var ref2 = (0,react.useState)(textProp.substring(0, 20)), text = ref2[0], setText = ref2[1];
    var elementRef = (0,react.useRef)(null);
    var originalRef = (0,react.useRef)(textProp);
    var watchRef = (0,react.useRef)(true);
    var lineHeightRef = (0,react.useRef)(0);
    var startRef = (0,react.useRef)(0);
    var middleRef = (0,react.useRef)(0);
    var endRef = (0,react.useRef)(0);
    var uuidRef = (0,react.useRef)(id);
    var ssr = "object" === "undefined";
    var action = function() {
        if (watchRef.current) {
            setNoClamp(false);
            clampLines();
            setExpanded(function(prevExpanded) {
                return !prevExpanded;
            });
        }
    };
    var clampLines = function() {
        if (!elementRef.current) return;
        setText("");
        var maxHeight = lineHeightRef.current * lines + 1;
        startRef.current = 0;
        middleRef.current = 0;
        endRef.current = originalRef.current.length;
        while(startRef.current <= endRef.current){
            middleRef.current = Math.floor((startRef.current + endRef.current) / 2);
            if (elementRef.current) {
                elementRef.current.innerText = originalRef.current.slice(0, middleRef.current);
            }
            if (middleRef.current === originalRef.current.length) {
                setText(originalRef.current);
                setNoClamp(true);
                return;
            }
            moveMarkers(maxHeight);
        }
        if (elementRef.current) {
            elementRef.current.innerText = originalRef.current.slice(0, middleRef.current - 5) + getEllipsis();
        }
        setText(originalRef.current.slice(0, middleRef.current - 5) + getEllipsis());
    };
    var moveMarkers = function(maxHeight) {
        if (elementRef.current && elementRef.current.clientHeight <= maxHeight) {
            startRef.current = middleRef.current + 1;
        } else {
            endRef.current = middleRef.current - 1;
        }
    };
    var getEllipsis = function() {
        return watchRef.current && !noClamp ? ellipsis : "";
    };
    var getButton = function() {
        if (noClamp || !buttons) return null;
        var buttonText = watchRef.current ? moreText : lessText;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
            variant: "link",
            onClick: clickHandler,
            "aria-controls": "clamped-content-".concat(uuidRef.current),
            "aria-expanded": !expanded,
            children: buttonText
        });
    };
    var clickHandler = function(e) {
        e.preventDefault();
        stopPropagationProp && e.stopPropagation();
        watchRef.current = !watchRef.current;
        watchRef.current ? clampLines() : setText(originalRef.current);
        setExpanded(function(prevExpanded) {
            return !prevExpanded;
        });
    };
    (0,react.useEffect)(function() {
        if (textProp && !ssr) {
            if (elementRef.current) {
                lineHeightRef.current = elementRef.current.clientHeight + 1;
            }
            clampLines();
            if (watchRef.current) {
                window.addEventListener("resize", (0,debounce/* default */.Z)(action, delay));
            }
        }
        return function() {
            if (!ssr) {
                window.removeEventListener("resize", (0,debounce/* default */.Z)(action, delay));
            }
        };
    }, [
        textProp
    ]);
    (0,react.useEffect)(function() {
        if (text !== textProp) {
            originalRef.current = textProp;
            clampLines();
        }
    }, [
        text
    ]);
    if (!textProp) {
        return null;
    }
    var InnerElement = innerElement;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Box["default"], {
        className: classNameProp,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(InnerElement, {
                ref: elementRef,
                id: "clamped-content-".concat(uuidRef.current),
                "aria-hidden": expanded,
                children: text
            }),
            getButton()
        ]
    });
};
/* harmony default export */ var ClampLines = (ClampLinesProps);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Image/index.js
var components_Image = __webpack_require__(15153);
;// CONCATENATED MODULE: ./src/components/pages/store/IconTag.tsx






var IconTag = function(param) {
    var text = param.text, iconUrl = param.iconUrl, boldText = param.boldText;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Box["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, containerStyles), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_Image/* default */.Z, {
                src: iconUrl,
                margin: "2",
                width: "4",
                alt: text
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                variant: "body2",
                fontWeight: boldText ? "bold" : "normal"
            }, textStyles), {
                children: text
            }))
        ]
    }));
};
var containerStyles = {
    display: "flex",
    flexDirection: "row",
    backgroundColor: "lilac.50",
    borderRadius: "100px",
    width: "fit-content",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "0.5rem",
    marginRight: "0.5rem"
};
var textStyles = {
    paddingRight: 2,
    marginBottom: "3px",
    color: "purple.400",
    lineHeight: "3"
};
/* harmony default export */ var store_IconTag = (IconTag);

// EXTERNAL MODULE: ./src/utils/useWindowSize.ts
var useWindowSize = __webpack_require__(55047);
;// CONCATENATED MODULE: ./src/components/pages/store/zag/ZagBuyingPrompt.tsx









var ZagBuyingPrompt = function(param) {
    var imageUrl = param.imageUrl, title = param.title, description = param.description, modalLinkText = param.modalLinkText;
    var retailerListDialog = (0,useDisclosure/* default */.Z)();
    var sku = (0,ProductPageContext/* useProduct */.i)().sku;
    var onModalClick = function() {
        retailerListDialog.onOpen();
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Box["default"], {
        display: "flex",
        alignItems: "center",
        p: "5",
        backgroundColor: "pink.400",
        borderRadius: "8",
        mb: "4",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], {
                mr: "4",
                children: imageUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                    src: imageUrl,
                    alt: "Zag Logo",
                    width: 78,
                    height: 78
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Box["default"], {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                        variant: "h6",
                        as: "h2",
                        mb: "3",
                        children: title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Typography["default"], {
                        variant: "body2",
                        fontWeight: "normal",
                        children: [
                            description,
                            " ",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                                variant: "link",
                                textDecoration: "underline",
                                onClick: onModalClick,
                                children: modalLinkText
                            })
                        ]
                    })
                ]
            }),
            retailerListDialog.isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RetailerListModal/* default */.Z, {
                showDefaultStore: true,
                isOpen: true,
                onClose: retailerListDialog.onClose,
                uid: sku === null || sku === void 0 ? void 0 : sku.uid,
                title: "Available brands"
            })
        ]
    });
};
/* harmony default export */ var zag_ZagBuyingPrompt = (ZagBuyingPrompt);

;// CONCATENATED MODULE: ./src/components/pages/store/CardSummary.tsx




















var style = {
    backLink: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin-bottom:", tokens_lib.spacing.spacing06, ";svg{margin-right:", tokens_lib.spacing.spacing04, ";color:", tokens_lib.colors.purple400, ";}a:focus{outline:5px auto Highlight;outline:5px auto -webkit-focus-ring-color;}"),
    alertBanner: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin-bottom:", tokens_lib.spacing.spacing04, " !important;box-shadow:none !important;a{color:", tokens_lib.colors.blue400, ";&:hover,&:focus{text-decoration:underline;}}")
};
var AlertObject = {
    critical: {
        color: "red",
        status: "error"
    },
    warning: {
        color: "yellow",
        status: "warning"
    },
    success: {
        color: "green",
        status: "success"
    },
    info: {
        color: "blue",
        status: "info"
    }
};
var CardSummary = function(param) {
    var iconTags = param.iconTags, zagBuyingPrompt = param.zagBuyingPrompt;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var retailerListDialog = (0,useDisclosure/* default */.Z)();
    var ref13 = (0,ProductPageContext/* useProduct */.i)(), sku = ref13.sku, isLayer = ref13.isLayer, configs = ref13.configs;
    var width = (0,useWindowSize/* default */.Z)().width;
    var skuTagTitle = (iconTags === null || iconTags === void 0 ? void 0 : iconTags.skuTagTitle) || "";
    var skuIconTags = (iconTags === null || iconTags === void 0 ? void 0 : (ref = iconTags.skuIconTags) === null || ref === void 0 ? void 0 : ref.items) || [];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], {
        pt: 6,
        w: {
            base: "100%",
            lg: "50%"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Box["default"], {
            mr: {
                lg: "70px"
            },
            position: {
                lg: "sticky"
            },
            top: {
                lg: "164px"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                    className: style.backLink,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((link_default()), {
                        href: "/store",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("a", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_es.FontAwesomeIcon, {
                                    icon: [
                                        "fas",
                                        "chevron-left"
                                    ]
                                }),
                                "Back"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Stack.VStack, {
                    spacing: "4",
                    mb: "2",
                    alignItems: "flex-start",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(store_CardDisplayImage, {}),
                        configs.featureLayerBuyingWeb && width < 987 && (sku === null || sku === void 0 ? void 0 : sku.layerEnabled) && (sku === null || sku === void 0 ? void 0 : sku.layerType) === "default" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(zag_ZagBuyingPrompt, {
                            imageUrl: zagBuyingPrompt === null || zagBuyingPrompt === void 0 ? void 0 : (ref1 = zagBuyingPrompt.elements) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.image) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.value) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.url,
                            title: zagBuyingPrompt === null || zagBuyingPrompt === void 0 ? void 0 : (ref5 = zagBuyingPrompt.elements) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.title) === null || ref6 === void 0 ? void 0 : ref6.value,
                            description: zagBuyingPrompt === null || zagBuyingPrompt === void 0 ? void 0 : (ref7 = zagBuyingPrompt.elements) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.description) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.value) === null || ref9 === void 0 ? void 0 : ref9.replace("{0}", sku.name),
                            modalLinkText: zagBuyingPrompt === null || zagBuyingPrompt === void 0 ? void 0 : (ref10 = zagBuyingPrompt.elements) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.zag_explanation_modal_link) === null || ref11 === void 0 ? void 0 : ref11.value
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                            variant: "h3",
                            as: "h1",
                            children: isLayer ? sku.layerDisplayName : sku.displayName
                        }),
                        ((ref12 = sku.alerts) === null || ref12 === void 0 ? void 0 : ref12.length) > 0 && sku.alerts.map(function(data, index) {
                            var level = data.level, title = data.title, messageMarkdown = data.messageMarkdown;
                            var alertProps = AlertObject[level];
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(lib.Alert, {
                                className: style.alertBanner,
                                fullWidth: true,
                                boxShadow: true,
                                status: alertProps.status,
                                color: alertProps.color,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.AlertIcon, {}),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(lib.AlertTextContainer, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.AlertTitle, {
                                                children: title
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.AlertDescription, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react_markdown/* ReactMarkdown */.D, {
                                                    children: messageMarkdown
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }, index);
                        }),
                        (sku === null || sku === void 0 ? void 0 : sku.descriptionShort) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ClampLines, {
                            lines: 3,
                            text: sku.descriptionShort,
                            id: "description-short"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                            variant: "body2",
                            color: "gray.600",
                            as: "h3",
                            children: sku.expiryTermDisplay
                        }),
                        skuTagTitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                            variant: "body1",
                            as: "h3",
                            children: skuTagTitle
                        }),
                        (skuIconTags === null || skuIconTags === void 0 ? void 0 : skuIconTags.length) > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], {
                            display: "flex",
                            flexWrap: "wrap",
                            children: skuIconTags.map(function(iconTag, index) {
                                var ref, ref1;
                                var text = iconTag.text;
                                var url = ((ref = iconTag.icon) === null || ref === void 0 ? void 0 : ref.items) && iconTag.icon.items.length ? iconTag.icon.items[0].url : null;
                                var boldText = !!(((ref1 = iconTag.boldText) === null || ref1 === void 0 ? void 0 : ref1.items) && iconTag.boldText.items.length > 0);
                                if (!url) return null;
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(store_IconTag, {
                                    text: text,
                                    iconUrl: url,
                                    boldText: boldText
                                }, index);
                            })
                        })
                    ]
                }),
                sku.isSwappable && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                            variant: "link",
                            onClick: retailerListDialog.onOpen,
                            children: "See all brands and retailers"
                        }),
                        retailerListDialog.isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RetailerListModal/* default */.Z, {
                            onClose: retailerListDialog.onClose,
                            uid: sku.uid
                        })
                    ]
                }),
                isLayer && retailerListDialog.isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RetailerListModal/* default */.Z, {
                    onClose: retailerListDialog.onClose,
                    title: "Available brands",
                    showDefaultStore: true
                })
            ]
        })
    });
};
/* harmony default export */ var store_CardSummary = (CardSummary);

// EXTERNAL MODULE: ./node_modules/@prezzee/components/lib/index.js
var components_lib = __webpack_require__(34906);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(42283);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ./src/models/purchaseForm.model.ts
var purchaseForm_model = __webpack_require__(28397);
// EXTERNAL MODULE: ./src/contexts/AuthContext.tsx + 2 modules
var AuthContext = __webpack_require__(35248);
;// CONCATENATED MODULE: ./src/components/pages/store/PickSection.tsx

















var PickSection_style = {
    valSelector: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:block;height:50px;min-width:70px;"),
    fieldset: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("& + fieldset{margin-top:", tokens_lib.spacing.spacing06, ";}"),
    column: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin-top:", tokens_lib.spacing.spacing025, ";"),
    disabled: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("color:", tokens_lib.colors.gray300, " !important;"),
    recipient: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin-top:", tokens_lib.spacing.spacing025, ";")
};
var PickSection = function(param) {
    var preselectedValue = param.preselectedValue;
    var segmentTrackPurchaseType = function segmentTrackPurchaseType(event) {
        var radioValue = event.target.value;
        customElementInteraction((0,_object_spread/* default */.Z)({
            element: radioValue === "self" ? "myself_cta" : "someone_else_cta",
            purchase_instance_id: purchaseInstanceId
        }, segmentStep));
    };
    var ref = (0,ProductPageContext/* useProduct */.i)(), _currency = ref.currency, cc = _currency.cc, symbol = _currency.symbol, sku = ref.sku, dispatch = ref.dispatch, state = ref.state, purchaseInstanceId = ref.purchaseInstanceId, configs = ref.configs, cardCustomisationState = ref.cardCustomisationState, isMultiPurchase = ref.isMultiPurchase;
    var user = (0,AuthContext/* default */.ZP)().user;
    var ref1 = (0,useSegment/* default */.Z)(), checkoutStepCompleted = ref1.checkoutStepCompleted, customElementInteraction = ref1.customElementInteraction, productAdded = ref1.productAdded, productRemoved = ref1.productRemoved;
    var ref2 = (0,index_esm/* useForm */.cI)({
        mode: "all",
        defaultValues: {
            purchaseType: state.formValues.purchaseType || (preselectedValue ? "friend" : null),
            value: state.formValues.value || preselectedValue || null
        }
    }), handleSubmit = ref2.handleSubmit, register = ref2.register, watch = ref2.watch, formState = ref2.formState;
    var ref3 = watch([
        "value",
        "purchaseType"
    ]), value = ref3.value, purchaseType = ref3.purchaseType;
    var segmentStep = {
        step: 1,
        step_name: "choose_step"
    };
    /**
   *  Send to preview and pay section if self checkout else continue through normal flow.
   */ var onSubmit = function(values) {
        var isSelfPurchase = values.purchaseType === "self";
        dispatch({
            type: ProductPageReducer/* ActionType.SetFormValues */.Us.SetFormValues,
            payload: values
        });
        dispatch({
            type: ProductPageReducer/* ActionType.SetPreviousStep */.Us.SetPreviousStep,
            payload: "choose_step"
        });
        checkoutStepCompleted((0,_object_spread/* default */.Z)({
            element: "save_and_continue_cta",
            purchase_instance_id: purchaseInstanceId,
            journey: purchaseType === "friend" ? "someone_else" : "myself",
            price: parseFloat(value)
        }, segmentStep));
        if (isSelfPurchase) {
            if (user) {
                dispatch({
                    type: ProductPageReducer/* ActionType.SetStep */.Us.SetStep,
                    payload: purchaseForm_model/* STEP.PREVIEW */.g.PREVIEW
                });
            } else {
                dispatch({
                    type: ProductPageReducer/* ActionType.SetStep */.Us.SetStep,
                    payload: purchaseForm_model/* STEP.SEND */.g.SEND
                });
            }
        } else {
            dispatch({
                type: ProductPageReducer/* ActionType.SetStep */.Us.SetStep,
                payload: purchaseForm_model/* STEP.WRAP */.g.WRAP
            });
        }
    };
    var handleProductAddedRemoved = function(denominationValue) {
        return function() {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6;
            var prevDenominationValue = state === null || state === void 0 ? void 0 : (ref = state.formValues) === null || ref === void 0 ? void 0 : ref.previousValue;
            var customTheme = cardCustomisationState === null || cardCustomisationState === void 0 ? void 0 : (ref1 = cardCustomisationState.customThemeDesigns) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.image;
            var selectedCardDesign = (cardCustomisationState === null || cardCustomisationState === void 0 ? void 0 : (ref3 = cardCustomisationState.selectedCardDesign) === null || ref3 === void 0 ? void 0 : ref3.isTemplate) && customTheme ? customTheme : cardCustomisationState === null || cardCustomisationState === void 0 ? void 0 : (ref4 = cardCustomisationState.selectedCardDesign) === null || ref4 === void 0 ? void 0 : ref4.imageUrl;
            var baseSegmentObject = {
                product_id: sku === null || sku === void 0 ? void 0 : sku.uid,
                sku: sku === null || sku === void 0 ? void 0 : sku.slug,
                name: sku === null || sku === void 0 ? void 0 : sku.displayName,
                quantity: 1,
                purchase_instance_id: purchaseInstanceId,
                step: 1,
                step_name: "pick_step",
                categories: sku === null || sku === void 0 ? void 0 : sku.categories.map(function(categories) {
                    return categories.name;
                }),
                category: (sku === null || sku === void 0 ? void 0 : sku.categories.length) > 0 && (sku === null || sku === void 0 ? void 0 : sku.categories[0].name),
                image_url: selectedCardDesign || (sku === null || sku === void 0 ? void 0 : (ref5 = sku.themes) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.image)
            };
            prevDenominationValue && productRemoved((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, baseSegmentObject), {
                price: parseFloat(prevDenominationValue)
            }));
            productAdded((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, baseSegmentObject), {
                price: parseFloat(denominationValue)
            }));
            // Setting the previous denomination value
            dispatch({
                type: ProductPageReducer/* ActionType.SetFormValues */.Us.SetFormValues,
                payload: {
                    previousValue: denominationValue
                }
            });
        };
    };
    var valuesDisabled = (0,react.useMemo)(function() {
        return !purchaseType;
    }, [
        purchaseType
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("fieldset", {
                className: PickSection_style.fieldset,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                        variant: "subtitle1",
                        as: "legend",
                        children: "Who are you gifting?"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Box["default"], {
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], {
                                flex: "1",
                                className: PickSection_style.recipient,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_lib.Radio, {
                                    id: "value-buyForMyself",
                                    name: "purchaseType",
                                    value: "self",
                                    ref: register({
                                        required: true
                                    }),
                                    fullWidth: true,
                                    variant: "contained",
                                    unselected: purchaseType && purchaseType !== "self",
                                    label: "Myself",
                                    className: PickSection_style.valSelector,
                                    onChange: segmentTrackPurchaseType
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], {
                                flex: "1",
                                className: PickSection_style.recipient,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_lib.Radio, {
                                    id: "value-buyAsGift",
                                    name: "purchaseType",
                                    value: "friend",
                                    ref: register({
                                        required: true
                                    }),
                                    fullWidth: true,
                                    variant: "contained",
                                    unselected: purchaseType && purchaseType !== "friend",
                                    label: "Someone else ".concat(isMultiPurchase ? "(up to ".concat(configs.classicMultiPurchaseMaxRecipient.toString(), ")") : ""),
                                    className: PickSection_style.valSelector,
                                    onChange: segmentTrackPurchaseType
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("fieldset", {
                className: PickSection_style.fieldset,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Typography["default"], {
                        variant: "subtitle1",
                        as: "legend",
                        className: valuesDisabled && PickSection_style.disabled,
                        marginBottom: "1",
                        children: [
                            "What's your gift value? (",
                            cc,
                            ")"
                        ]
                    }),
                    isMultiPurchase && purchaseType === "friend" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                        as: "p",
                        variant: "body2",
                        fontWeight: "normal",
                        color: "gray.600",
                        className: valuesDisabled && PickSection_style.disabled,
                        children: "If you're gifting a group of people, they will each get the amount you choose."
                    }),
                    sku.denominations && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], {
                        display: "grid",
                        gap: "10px",
                        mt: "10px",
                        gridTemplateColumns: {
                            base: "repeat(3,1fr)",
                            md: "repeat(4, 1fr)",
                            xl: "repeat(5, 1fr)"
                        },
                        children: sortBy_default()(sku.denominations.map(function(denomination) {
                            return Number(denomination.value);
                        })).map(function(denominationValueAsNumber, index) {
                            var denominationValue = denominationValueAsNumber.toFixed(2);
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_lib.Radio, {
                                    id: "value-".concat(denominationValue),
                                    name: "value",
                                    value: denominationValue,
                                    ref: register({
                                        required: true
                                    }),
                                    fullWidth: true,
                                    variant: "contained",
                                    unselected: value && denominationValue !== value,
                                    label: symbol + denominationValue.replace(/\.00/g, ""),
                                    className: PickSection_style.valSelector,
                                    onClick: handleProductAddedRemoved(denominationValue),
                                    disabled: valuesDisabled
                                })
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                type: "submit",
                fullWidth: true,
                size: "lg",
                mt: "6",
                mb: "4",
                isDisabled: !formState.isValid,
                children: "Save and continue"
            })
        ]
    });
};
/* harmony default export */ var store_PickSection = (PickSection);

;// CONCATENATED MODULE: ./src/components/pages/store/AccordionStep.tsx





var AccordionStep_style = {
    container: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("border:1px solid ", tokens_lib.colors.gray300, ";border-radius:4px;// Should come from tokens\n    width:100%;margin-bottom:", tokens_lib.spacing.spacing04, ";"),
    content: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("padding:0 ", tokens_lib.spacing.spacing05, ";@media (max-width:1288px){padding:0 ", tokens_lib.spacing.spacing04, ";}"),
    toggle: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("position:relative;padding:", tokens_lib.spacing.spacing05, " calc(", tokens_lib.spacing.spacing05, " + ", tokens_lib.spacing.spacing10, ") ", tokens_lib.spacing.spacing05, " ", tokens_lib.spacing.spacing05, ";text-align:left;width:100%;@media (max-width:1288px){padding:", tokens_lib.spacing.spacing05, " calc(", tokens_lib.spacing.spacing04, " + ", tokens_lib.spacing.spacing10, ") ", tokens_lib.spacing.spacing05, " ", tokens_lib.spacing.spacing04, ";}&:active{outline:none;}&:disabled{pointer-events:none;}"),
    title: function(disabled) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("color:", disabled ? "".concat(tokens_lib.colors.gray500, " !important") : "inherit", ";margin-right:", tokens_lib.spacing.spacing04, ";");
    },
    subtitle: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("color:", tokens_lib.colors.gray500, ";line-height:1.8em !important;"),
    toggleActionText: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("position:absolute;right:", tokens_lib.spacing.spacing05, ";top:50%;transform:translateY(-50%);color:", tokens_lib.colors.notificationBlue, " !important;@media (max-width:576px){margin-top:2px !important;//Better aligns the text on mobile}@media (max-width:1288px){right:", tokens_lib.spacing.spacing04, ";};"),
    text: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;align-items:baseline;")
};
var AccordionStep = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var children = param.children, title = param.title, subtitle = param.subtitle, _stepIndex = param.stepIndex, stepIndex = _stepIndex === void 0 ? 0 : _stepIndex, _currentStep = param.currentStep, currentStep = _currentStep === void 0 ? 0 : _currentStep, _furthestStep = param.furthestStep, furthestStep = _furthestStep === void 0 ? 0 : _furthestStep, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _hidden = param.hidden, hidden = _hidden === void 0 ? false : _hidden, onToggle = param.onToggle;
    var handleToggleClick = function() {
        onToggle && onToggle();
    };
    var expanded = !disabled && !hidden;
    var ariaTitle = "step-" + title.toLowerCase().split(" ").join("-");
    var isActive = currentStep === stepIndex;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("section", {
        className: AccordionStep_style.container,
        ref: ref,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("h3", {
                className: "sr-only",
                children: [
                    title,
                    hidden && subtitle
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("button", {
                className: AccordionStep_style.toggle,
                onClick: handleToggleClick,
                disabled: disabled || !hidden,
                "aria-controls": "".concat(ariaTitle, "-content"),
                "aria-expanded": expanded,
                id: "".concat(ariaTitle, "-toggle"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_lib.Row, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(components_lib.Col, {
                            className: AccordionStep_style.text,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_lib.Typography, {
                                    variant: "h5",
                                    component: "span",
                                    className: AccordionStep_style.title(disabled),
                                    children: title
                                }),
                                subtitle && !isActive && (hidden || furthestStep > stepIndex) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_lib.Typography, {
                                    component: "span",
                                    className: AccordionStep_style.subtitle,
                                    children: subtitle
                                })
                            ]
                        })
                    }),
                    hidden && !disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_lib.Typography, {
                        className: AccordionStep_style.toggleActionText,
                        component: "span",
                        variant: "body2",
                        children: "EDIT"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                className: AccordionStep_style.content,
                "aria-hidden": !expanded,
                id: "".concat(ariaTitle, "-content"),
                children: !disabled && !hidden && children
            })
        ]
    });
});
AccordionStep.displayName = "AccordionStep";
/* harmony default export */ var store_AccordionStep = (AccordionStep);

// EXTERNAL MODULE: ./src/components/library/SeoMeta.tsx
var SeoMeta = __webpack_require__(48882);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react-easy-crop/index.module.js + 1 modules
var index_module = __webpack_require__(83913);
// EXTERNAL MODULE: ./node_modules/js-convert-case/index.js
var js_convert_case = __webpack_require__(24417);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/theme/foundations/colors.js
var colors = __webpack_require__(85171);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Modal/index.js
var Modal = __webpack_require__(15115);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Slider/index.js
var Slider = __webpack_require__(19426);
// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
;// CONCATENATED MODULE: ./src/hooks/useCustomCardDesign.ts



var useCustomCardDesign = function() {
    var createImage = function(url) {
        return new Promise(function(resolve, reject) {
            var image = new Image();
            image.addEventListener("load", function() {
                return resolve(image);
            });
            image.addEventListener("error", function(error) {
                return reject(error);
            });
            image.setAttribute("crossOrigin", "anonymous"); // needed to avoid cross-origin issues on CodeSandbox
            image.src = url;
        });
    };
    var generateImageBlob = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var imageSrc, pixelCrop, _resizeParams, resizeParams, _resize, resize, image, canvas, canvasContext, data, resizedCanvas, ctx;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        imageSrc = param.imageSrc, pixelCrop = param.pixelCrop, _resizeParams = param.resizeParams, resizeParams = _resizeParams === void 0 ? {
                            width: 452,
                            height: 280
                        } : _resizeParams, _resize = param.resize, resize = _resize === void 0 ? true : _resize;
                        return [
                            4,
                            createImage(imageSrc)
                        ];
                    case 1:
                        image = _state.sent();
                        canvas = document.createElement("canvas");
                        canvasContext = canvas.getContext("2d");
                        if (!canvasContext) {
                            return [
                                2,
                                null
                            ];
                        }
                        canvas.width = image.width;
                        canvas.height = image.height;
                        canvasContext.drawImage(image, 0, 0);
                        data = canvasContext.getImageData(pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height);
                        canvas.width = pixelCrop.width;
                        canvas.height = pixelCrop.height;
                        canvasContext.putImageData(data, 0, 0);
                        if (resize) {
                            resizedCanvas = document.createElement("canvas");
                            ctx = resizedCanvas.getContext("2d");
                            resizedCanvas.width = resizeParams.width;
                            resizedCanvas.height = resizeParams.height;
                            ctx.fillStyle = "#fff";
                            ctx.fillRect(0, 0, resizedCanvas.width, resizedCanvas.height);
                            ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, resizeParams.width, resizeParams.height);
                            return [
                                2,
                                new Promise(function(resolve) {
                                    resizedCanvas.toBlob(function(file) {
                                        resolve(file);
                                    }, "image/jpeg");
                                })
                            ];
                        } else {
                            return [
                                2,
                                new Promise(function(resolve) {
                                    canvas.toBlob(function(file) {
                                        resolve(file);
                                    }, "image/jpeg");
                                })
                            ];
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function generateImageBlob(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var getImageFileDataUrl = function(imageFile) {
        var encodeImageFileAsURL = function() {
            if (!imageFile || !imageFile.type.startsWith("image/")) return "";
            var image = new Image();
            image.src = URL.createObjectURL(imageFile);
            return image.src;
        };
        return {
            encodeImageFileAsURL: encodeImageFileAsURL
        };
    };
    var uploadImage = function(blob, templateUid, endpointUrl) {
        var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.acceptContentTypeJson */.oK.acceptContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
        var formData = new FormData();
        formData.set("uid", templateUid);
        formData.append("image", blob, "image.jpg");
        var init = {
            headers: headers,
            method: "POST",
            body: formData
        };
        return fetch(endpointUrl, init);
    };
    return {
        createImage: createImage,
        generateImageBlob: generateImageBlob,
        getImageFileDataUrl: getImageFileDataUrl,
        uploadImage: uploadImage
    };
};
/* harmony default export */ var hooks_useCustomCardDesign = (useCustomCardDesign);

// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(31611);
;// CONCATENATED MODULE: ./src/components/pages/store/CustomCardDesign.tsx




















var CARD_CROP_SIZE = {
    width: 452,
    height: 280
};
var DESIGN_UPLOAD_API = "https://www.prezzee.com.au/" + "api/v3/designs/";
var MIN_ZOOM = 0.1;
var MAX_ZOOM = 3;
var ZOOM_STEP_INCREMENT = 0.1;
var CustomCardDesign = function() {
    var ref = (0,react.useState)(""), imageSrc = ref[0], setImageSrc = ref[1];
    var ref1 = (0,react.useState)(false), cropperModalIsVisible = ref1[0], setCropperModalIsVisible = ref1[1];
    var ref2 = (0,react.useState)(false), generateImg = ref2[0], setGenerateImg = ref2[1];
    var ref3 = (0,react.useState)({
        x: 0,
        y: 0
    }), crop = ref3[0], setCrop = ref3[1];
    var ref4 = (0,react.useState)(1), zoom = ref4[0], setZoom = ref4[1];
    var ref5 = (0,react.useState)(null), croppedAreaPixels = ref5[0], setCroppedAreaPixels = ref5[1];
    var ref6 = (0,react.useState)(null), croppedImage = ref6[0], setCroppedImage = ref6[1];
    var ref7 = hooks_useCustomCardDesign(), generateImageBlob = ref7.generateImageBlob, getImageFileDataUrl = ref7.getImageFileDataUrl, uploadImage = ref7.uploadImage;
    var ref8 = (0,ProductPageContext/* useProduct */.i)(), cardCustomisationState = ref8.cardCustomisationState, dispatchCardCustomisationAction = ref8.dispatchCardCustomisationAction, userUploadedDesignFileInput = ref8.userUploadedDesignFileInput;
    var uid = cardCustomisationState.selectedCardDesign.uid;
    var incrementZoom = function() {
        var nextStep = zoom + ZOOM_STEP_INCREMENT;
        setZoom(Math.min(nextStep, MAX_ZOOM));
    };
    var decrementZoom = function() {
        var prevStep = zoom - ZOOM_STEP_INCREMENT;
        setZoom(Math.max(prevStep, MIN_ZOOM));
    };
    var reset = function() {
        if (zoom !== 1 || crop.x !== 0 || crop.y !== 0) {
            setZoom(1);
            setCrop({
                x: 0,
                y: 0
            });
        }
    };
    var onFileChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(ev) {
            var ref, file, imageDataUrl, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                ev.preventDefault();
                if (((ref = ev.target.files) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                    file = ev.target.files[0];
                    imageDataUrl = getImageFileDataUrl(file);
                    ;
                    setImageSrc((ref1 = imageDataUrl === null || imageDataUrl === void 0 ? void 0 : imageDataUrl.encodeImageFileAsURL) !== null && ref1 !== void 0 ? ref1 : "");
                    setCropperModalIsVisible(true);
                }
                return [
                    2
                ];
            });
        });
        return function onFileChange(ev) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function(ev) {
        if (ev) {
            ev.preventDefault();
        }
        setCropperModalIsVisible(false);
        setCroppedImage(null);
        reset();
    };
    var handleSuccess = function(result) {
        var customThemeDesign = (0,js_convert_case.camelKeys)(result, {
            recursive: true,
            recursiveInArray: true
        });
        dispatchCardCustomisationAction({
            type: CardCustomisationReducer/* ActionType.CreateCustomThemeDesign */.Us.CreateCustomThemeDesign,
            payload: {
                templateUid: uid,
                customThemeDesign: customThemeDesign
            }
        });
        reset();
        setCropperModalIsVisible(false);
    };
    //set area
    var onCropComplete = (0,react.useCallback)(function(_, croppedAreaPixels) {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);
    var onCropped = react.useCallback(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(croppedImg) {
            var result, json, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!croppedImage) return [
                            3,
                            7
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            uploadImage(croppedImg, uid, DESIGN_UPLOAD_API)
                        ];
                    case 2:
                        result = _state.sent();
                        if (!result.ok) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            result.json()
                        ];
                    case 3:
                        json = _state.sent();
                        setGenerateImg(false);
                        handleSuccess(json);
                        return [
                            2
                        ];
                    case 4:
                        return [
                            4,
                            result.json()
                        ];
                    case 5:
                        _state.sent();
                        setGenerateImg(false);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        e = _state.sent();
                        logger/* default.info */.ZP.info({
                            message: "info: could not generate image with Custom Theme Cropper",
                            error: e
                        });
                        setGenerateImg(false);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function(croppedImg) {
            return _ref.apply(this, arguments);
        };
    }(), [
        generateImg,
        handleSuccess,
        uid,
        DESIGN_UPLOAD_API
    ]);
    var showCroppedImage = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var croppedImg, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setGenerateImg(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        generateImageBlob({
                            imageSrc: imageSrc,
                            pixelCrop: croppedAreaPixels
                        })
                    ];
                case 2:
                    croppedImg = _state.sent();
                    setCroppedImage(croppedImg);
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    logger/* default.warn */.ZP.warn({
                        message: "could not crop image",
                        error: e
                    });
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        croppedAreaPixels
    ]);
    (0,react.useEffect)(function() {
        onCropped(croppedImage);
    }, [
        croppedImage
    ]);
    if (!(cardCustomisationState === null || cardCustomisationState === void 0 ? void 0 : cardCustomisationState.selectedCardDesign)) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Modal/* Modal */.u_, {
                isOpen: !!(cropperModalIsVisible && uid && imageSrc),
                size: "4xl",
                onClose: function() {
                    return handleCancel();
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalOverlay */.ZA, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Modal/* ModalContent */.hz, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalHeader */.xB, {
                                textAlign: "center",
                                fontSize: {
                                    sm: "2xl",
                                    base: "lg"
                                },
                                borderBottom: "1px",
                                borderBottomColor: colors["default"].gray[200],
                                px: "24",
                                children: "Resize & Crop"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalCloseButton */.ol, {
                                top: {
                                    sm: "5",
                                    base: "4"
                                },
                                right: "6",
                                w: {
                                    sm: "8",
                                    base: "7"
                                },
                                h: {
                                    sm: "8",
                                    base: "7"
                                }
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Button["default"], {
                                variant: "link",
                                type: "button",
                                position: "absolute",
                                left: "6",
                                top: {
                                    sm: "6",
                                    base: "5"
                                },
                                color: colors["default"].notification.blue,
                                onClick: function() {
                                    return reset();
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_es.FontAwesomeIcon, {
                                        icon: [
                                            "far",
                                            "undo"
                                        ],
                                        size: "xs"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                                        ml: "1",
                                        variant: "subtitle3",
                                        as: "span",
                                        mb: "2px",
                                        children: "Refresh"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalBody */.fe, {
                                py: "0",
                                px: "5",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Container/* default */.Z, {
                                    className: CustomCardDesign_Styles.cropperContainer,
                                    w: "100%",
                                    maxW: "100%",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_module/* default */.ZP, {
                                        aspect: CARD_CROP_SIZE.width / CARD_CROP_SIZE.height,
                                        crop: crop,
                                        // cropSize={CARD_CROP_SIZE}
                                        image: imageSrc,
                                        minZoom: 0.1,
                                        onCropComplete: onCropComplete,
                                        onCropChange: setCrop,
                                        onZoomChange: setZoom,
                                        restrictPosition: true,
                                        showGrid: false,
                                        zoom: zoom,
                                        zoomWithScroll: false
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalFooter */.mz, {
                                justifyContent: "center",
                                px: "5",
                                py: "4",
                                borderTop: "1px",
                                borderTopColor: colors["default"].gray[200],
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Stack.HStack, {
                                    w: "100%",
                                    wrap: {
                                        sm: "nowrap",
                                        base: "wrap"
                                    },
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], {
                                            pl: "0",
                                            w: "100%",
                                            mb: {
                                                sm: "0",
                                                base: "3"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Stack.HStack, {
                                                alignContent: "center",
                                                spacing: "4",
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                                                        variant: "tertiary",
                                                        type: "button",
                                                        onClick: function() {
                                                            return decrementZoom();
                                                        },
                                                        className: CustomCardDesign_Styles.stepButton,
                                                        color: colors["default"].red[400],
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_es.FontAwesomeIcon, {
                                                            icon: [
                                                                "fas",
                                                                "minus"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], {
                                                        w: "100%",
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Slider/* Slider */.iR, {
                                                            "aria-label": "slider-zoom",
                                                            min: 0.1,
                                                            max: 3,
                                                            step: 0.01,
                                                            value: zoom,
                                                            onChange: function(value) {
                                                                return setZoom(value);
                                                            },
                                                            display: "block",
                                                            children: [
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Slider/* SliderTrack */.Uj, {
                                                                    height: 1,
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Slider/* SliderFilledTrack */.Ms, {})
                                                                }),
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Slider/* SliderThumb */.gs, {
                                                                    boxSize: 7,
                                                                    border: "3px",
                                                                    borderStyle: "solid",
                                                                    borderColor: colors["default"].red[400],
                                                                    backgroundColor: "white"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                                                        variant: "tertiary",
                                                        type: "button",
                                                        onClick: function() {
                                                            return incrementZoom();
                                                        },
                                                        className: CustomCardDesign_Styles.stepButton,
                                                        color: colors["default"].red[400],
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_es.FontAwesomeIcon, {
                                                            icon: [
                                                                "fas",
                                                                "plus"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], {
                                            width: {
                                                sm: "156px",
                                                base: "100%"
                                            },
                                            className: CustomCardDesign_Styles.submitButtonWrapper,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                                                isDisabled: generateImg,
                                                onClick: function() {
                                                    return showCroppedImage();
                                                },
                                                fullWidth: true,
                                                children: generateImg ? "Uploading..." : "Crop & Save"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("input", {
                value: "",
                type: "file",
                id: "file",
                ref: userUploadedDesignFileInput,
                accept: "image/png, image/jpeg",
                onChange: onFileChange,
                className: CustomCardDesign_Styles.fileInput
            })
        ]
    });
};
var CustomCardDesign_Styles = {
    cropperContainer: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("position:relative;cursor:crosshair;overflow:hidden;max-width:100%;padding-top:", Math.round(CARD_CROP_SIZE.height / CARD_CROP_SIZE.width * 100), "%;.reactEasyCrop_CropArea{box-shadow:0 0 9999em rgb(255,255,255);border-color:", colors["default"].gray[200], ";}"),
    submitButtonWrapper: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("@media (max-width:424px){margin-left:0 !important;}"),
    stepButton: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("&:hover{background-color:transparent !important;}"),
    fileInput: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:none;")
};
/* harmony default export */ var store_CustomCardDesign = (CustomCardDesign);

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/icons/SparklesIcon.js
var SparklesIcon = __webpack_require__(92265);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/icons/ChevronLeftIcon.js
var ChevronLeftIcon = __webpack_require__(50256);
// EXTERNAL MODULE: ./src/common/util.ts + 3 modules
var util = __webpack_require__(42358);
;// CONCATENATED MODULE: ./src/components/pages/store/zag/SwappableCardModal.tsx














var SwappableCardModal = function(param) {
    var onClose = param.onClose;
    var retailerListDialog = (0,useDisclosure/* default */.Z)();
    var ref = (0,ProductPageContext/* useProduct */.i)(), uid = ref.sku.uid;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Modal/* Modal */.u_, {
                isOpen: true,
                onClose: onClose,
                isCentered: true,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalOverlay */.ZA, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Modal/* ModalContent */.hz, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalHeader */.xB, {
                                pb: 0,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                                    variant: "h2",
                                    color: "gray.800",
                                    fontSize: "24",
                                    fontWeight: "bold",
                                    children: "Prezzee Plus eGift Card"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalCloseButton */.ol, {
                                mt: 3
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Modal/* ModalBody */.fe, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                                        variant: "body",
                                        color: "gray.600",
                                        fontSize: "16",
                                        lineHeight: "24px",
                                        fontWeight: "normal",
                                        mb: 4,
                                        children: "This unique Prezzee-issued card gives recipients the freedom to choose where to spend it; at the brand you selected for them, or at another available brand of their choice."
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                                        variant: "body",
                                        color: "gray.600",
                                        fontSize: "16",
                                        lineHeight: "24px",
                                        fontWeight: "normal",
                                        mb: 4,
                                        children: "Buying a Prezzee Plus eGift Card is a great way to ensure your giftee gets the most out of their gift and treat themselves to something they truly love, need or want!"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                                        variant: "body",
                                        color: "gray.600",
                                        fontSize: "16",
                                        lineHeight: "24px",
                                        fontWeight: "normal",
                                        mb: 4,
                                        children: util/* envUtil.getCountry */.vK.getCountry() === util/* COUNTRY.UnitedStates */.si.UnitedStates ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                            children: "Prezzee Plus eGift Cards have no expiry date. Once a brand is selected, a new card will be issued and Terms and Conditions will be according to the chosen brand."
                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                            children: "Prezzee Plus eGift Cards are valid for 3 years from the date of issue. Once a brand is selected, a new eGift Card will be issued and the expiry date and the Terms and Conditions will be according to the chosen brand."
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Stack.VStack, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, buttonStackStyles), {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                                                color: "blue.500",
                                                fontSize: "16px",
                                                fontWeight: "normal",
                                                onClick: retailerListDialog.onOpen,
                                                textDecoration: "underline",
                                                variant: "link",
                                                mb: 4,
                                                children: "See available brands"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                                                variant: "primary",
                                                onClick: onClose,
                                                width: "full",
                                                children: "Got it"
                                            })
                                        ]
                                    }))
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RetailerListModal/* default */.Z, {
                showDefaultStore: true,
                isOpen: retailerListDialog.isOpen,
                onClose: function() {
                    retailerListDialog.onClose();
                    onClose();
                },
                uid: uid,
                title: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                            leftIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ChevronLeftIcon/* default */.Z, {})
                            }),
                            variant: "unstyled",
                            onClick: retailerListDialog.onClose,
                            children: "Back"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("br", {}),
                        "Available brands"
                    ]
                })
            })
        ]
    });
};
var buttonStackStyles = {
    justifyContent: "flex-start",
    alignItems: "flex-start",
    mb: 4
};
/* harmony default export */ var zag_SwappableCardModal = (SwappableCardModal);

;// CONCATENATED MODULE: ./src/components/pages/store/zag/ZagUpgradePrompt.tsx











var ZagUpgradePrompt = function() {
    var setHasUpgradedZag = (0,ProductPageContext/* useProduct */.i)().setHasUpgradedZag;
    var swappableCardModal = (0,useDisclosure/* default */.Z)();
    var customElementInteraction = (0,useSegment/* default */.Z)().customElementInteraction;
    var purchaseInstanceId = (0,ProductPageContext/* useProduct */.i)().purchaseInstanceId;
    var handleSwappableClick = function() {
        setHasUpgradedZag(true);
        customElementInteraction({
            element: "zag_upgrade_cta",
            purchase_instance_id: purchaseInstanceId
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Box["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ZagUpgradePrompt_containerStyles), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Box["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, titleContainerStyles), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, iconContainerStyles), {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SparklesIcon/* default */.Z, {
                            color: "purple.400"
                        })
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                        variant: "h4",
                        as: "h2",
                        color: "gray.800",
                        fontWeight: "semibold",
                        children: "Give more (for free!)"
                    })
                ]
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                variant: "body",
                color: "gray.600",
                fontSize: "16",
                lineHeight: "24px",
                fontWeight: "normal",
                children: "Convert this gift into a Prezzee Plus eGift Card and let your giftee choose where to spend it; at this brand or at another available brand of their choice."
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                variant: "primary",
                onClick: handleSwappableClick
            }, baseButtonStyles), {
                children: "Give them more"
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                variant: "link",
                color: "purple.400"
            }, baseButtonStyles), {
                onClick: swappableCardModal.onOpen,
                children: "What is a Prezzee Plus eGift Card?"
            })),
            swappableCardModal.isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(zag_SwappableCardModal, {
                onClose: swappableCardModal.onClose
            })
        ]
    }));
};
/* harmony default export */ var zag_ZagUpgradePrompt = (ZagUpgradePrompt);
var ZagUpgradePrompt_containerStyles = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    backgroundColor: "lilac.50",
    marginBottom: "4",
    padding: "4",
    borderRadius: "md"
};
var titleContainerStyles = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    mb: "3"
};
var iconContainerStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mr: "4",
    height: "10",
    width: "10",
    backgroundColor: "white",
    borderRadius: "full",
    padding: "2"
};
var baseButtonStyles = {
    my: "3"
};

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/icons/CheckIcon.js
var CheckIcon = __webpack_require__(91306);
;// CONCATENATED MODULE: ./src/components/pages/store/zag/UpgradeConfirmationBanner.tsx









var UpgradeConfirmationBanner = function() {
    var setHasUpgradedZag = (0,ProductPageContext/* useProduct */.i)().setHasUpgradedZag;
    var customElementInteraction = (0,useSegment/* default */.Z)().customElementInteraction;
    var purchaseInstanceId = (0,ProductPageContext/* useProduct */.i)().purchaseInstanceId;
    var handleBackClick = function() {
        setHasUpgradedZag(false);
        customElementInteraction({
            element: "zag_go_back_cta",
            purchase_instance_id: purchaseInstanceId
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Box["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, UpgradeConfirmationBanner_containerStyles), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Box["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, UpgradeConfirmationBanner_titleContainerStyles), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, UpgradeConfirmationBanner_iconContainerStyles), {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CheckIcon/* default */.Z, {
                            boxSize: 4,
                            variant: "light",
                            color: "purple.400"
                        })
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                        variant: "h4",
                        as: "h2",
                        color: "gray.800",
                        fontWeight: "semibold",
                        children: "You've selected a Prezzee Plus eGift Card, great choice!"
                    })
                ]
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                variant: "body",
                color: "gray.600",
                fontWeight: "normal",
                mb: 2,
                children: "Giftees love these cards as they can choose where to spend them."
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                variant: "body",
                fontWeight: "bold",
                children: "Don't want a Prezzee Plus eGift Card?"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                color: "blue.500",
                fontWeight: "normal",
                onClick: handleBackClick,
                textDecoration: "underline",
                variant: "link",
                justifyContent: "flex-start",
                children: "Go back"
            })
        ]
    }));
};
var UpgradeConfirmationBanner_containerStyles = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    backgroundColor: "lilac.50",
    marginBottom: "4",
    padding: "4",
    borderRadius: "md"
};
var UpgradeConfirmationBanner_titleContainerStyles = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    mb: "3"
};
var UpgradeConfirmationBanner_iconContainerStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mr: "4",
    height: "40px",
    width: "40px",
    minHeight: "40px",
    minWidth: "40px",
    backgroundColor: "white",
    borderRadius: "full",
    padding: "2"
};
/* harmony default export */ var zag_UpgradeConfirmationBanner = (UpgradeConfirmationBanner);

;// CONCATENATED MODULE: ./src/components/pages/store/zag/ZagUpgradeWrapper.tsx




var ZagUpgradeWrapper = function() {
    var isLayer = (0,ProductPageContext/* useProduct */.i)().isLayer;
    return !isLayer ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(zag_ZagUpgradePrompt, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(zag_UpgradeConfirmationBanner, {});
};
/* harmony default export */ var zag_ZagUpgradeWrapper = (ZagUpgradeWrapper);

// EXTERNAL MODULE: ./src/utils/ProductPageSegmentHook.bs.js
var ProductPageSegmentHook_bs = __webpack_require__(50857);
// EXTERNAL MODULE: ./src/utils/ProductPageHelpers.ts
var ProductPageHelpers = __webpack_require__(69477);
// EXTERNAL MODULE: ./src/contexts/LayoutDataContext.ts
var LayoutDataContext = __webpack_require__(25149);
;// CONCATENATED MODULE: ./src/components/pages/store/ProductPage.tsx







// Hooks


// Reducers


// SSR Components








// Dynamic Components
var FullCardDetails = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4669).then(__webpack_require__.bind(__webpack_require__, 54669));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(54669)
            ];
        }
    },
    ssr: false
});
var ZagCardDetails = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6119).then(__webpack_require__.bind(__webpack_require__, 66119));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66119)
            ];
        }
    },
    ssr: false
});
var PreviewSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7301), __webpack_require__.e(9915), __webpack_require__.e(7864), __webpack_require__.e(296), __webpack_require__.e(8764), __webpack_require__.e(653), __webpack_require__.e(8137), __webpack_require__.e(7342), __webpack_require__.e(2769), __webpack_require__.e(8805), __webpack_require__.e(6694), __webpack_require__.e(9807), __webpack_require__.e(1674), __webpack_require__.e(3562), __webpack_require__.e(9464), __webpack_require__.e(3010), __webpack_require__.e(1580), __webpack_require__.e(444), __webpack_require__.e(8932), __webpack_require__.e(9142), __webpack_require__.e(3242)]).then(__webpack_require__.bind(__webpack_require__, 13242));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(13242)
            ];
        }
    },
    ssr: false
});
var PaymentSummary = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6694), __webpack_require__.e(5384), __webpack_require__.e(5210)]).then(__webpack_require__.bind(__webpack_require__, 65210));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(65210)
            ];
        }
    },
    ssr: false
});
var WrapSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7301), __webpack_require__.e(8764), __webpack_require__.e(9304), __webpack_require__.e(7342), __webpack_require__.e(6694), __webpack_require__.e(124), __webpack_require__.e(345)]).then(__webpack_require__.bind(__webpack_require__, 80345));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80345)
            ];
        }
    }
});
var AlertBox = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6561).then(__webpack_require__.bind(__webpack_require__, 16561));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16561)
            ];
        }
    },
    ssr: false
});
var PromoModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2861).then(__webpack_require__.bind(__webpack_require__, 2861));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2861)
            ];
        }
    },
    ssr: false
});
var RetailerTnCModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4965).then(__webpack_require__.bind(__webpack_require__, 94965));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94965)
            ];
        }
    },
    ssr: false
});
var PaypalCancelledModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4766).then(__webpack_require__.bind(__webpack_require__, 24766));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24766)
            ];
        }
    },
    ssr: false
});
var DeliverSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9915), __webpack_require__.e(8137), __webpack_require__.e(7342), __webpack_require__.e(2769), __webpack_require__.e(9198), __webpack_require__.e(1674), __webpack_require__.e(9464), __webpack_require__.e(8658), __webpack_require__.e(3841)]).then(__webpack_require__.bind(__webpack_require__, 83841));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83841)
            ];
        }
    },
    ssr: false
});
var SuccessView = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7301), __webpack_require__.e(8137), __webpack_require__.e(7342), __webpack_require__.e(2769), __webpack_require__.e(8805), __webpack_require__.e(9198), __webpack_require__.e(6134), __webpack_require__.e(1241), __webpack_require__.e(1580), __webpack_require__.e(444), __webpack_require__.e(7472), __webpack_require__.e(3262), __webpack_require__.e(114)]).then(__webpack_require__.bind(__webpack_require__, 30114)).then(function(mod) {
        return mod.make;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30114)
            ];
        }
    },
    ssr: false
});
// Utils








var ProductPage = function(param) {
    var sku = param.sku, configs = param.configs, skuPresentation = param.skuPresentation, personalisedMessages = param.personalisedMessages, giftThemes = param.giftThemes, zagBuyingPrompt = param.zagBuyingPrompt;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    var ref20 = (0,_sliced_to_array/* default */.Z)((0,ProductPageReducer/* useProductPageReducer */.gj)((configs === null || configs === void 0 ? void 0 : configs.featureStripeBillingAddress) || false), 2), state = ref20[0], dispatch = ref20[1];
    var isFirstRender = (0,useIsFirstRender/* default */.Z)();
    var formValues = state.formValues;
    var user = (0,AuthContext/* default */.ZP)().user;
    var ref21 = (0,react.useState)(false), hasUpgradedZag = ref21[0], setHasUpgradedZag = ref21[1];
    var ref22 = (0,react.useState)((0,ProductPageSegmentHook_bs/* generateUniqueUserId */.QX)()), purchaseInstanceId = ref22[0], _ = ref22[1];
    var ref23 = (0,useSegment/* default */.Z)(), productViewed = ref23.productViewed, checkoutStepViewed = ref23.checkoutStepViewed, checkoutStepCompleted = ref23.checkoutStepCompleted, customElementInteraction = ref23.customElementInteraction;
    var currencyCode = sku === null || sku === void 0 ? void 0 : (ref = sku.denominations) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.valueCurrency;
    var ref24 = (0,util/* getCurrency */.zC)(currencyCode) || {}, cc = ref24.cc, symbol = ref24.symbol, name = ref24.name;
    var currency = {
        cc: cc,
        symbol: symbol,
        name: name
    };
    var width = (0,useWindowSize/* default */.Z)().width;
    var router = (0,next_router.useRouter)();
    var preselectedValueQuery = (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.value;
    var formattedPreselectedValue = (0,ProductPageHelpers/* formatValue */.Bw)(preselectedValueQuery);
    var preselectedValueExists = sku.denominations.some(function(denomination) {
        return denomination.value === formattedPreselectedValue;
    });
    var ref25 = (0,react.useState)(false), invalidValuePopupVisible = ref25[0], setInvalidValuePopupVisible = ref25[1];
    var warnings = (0,LayoutDataContext/* useLayoutData */.Q)().warnings;
    var preselectValueWarnings = warnings && warnings.find(function(warning) {
        return warning.id === "card_denomination_not_available";
    }) || {
        heading: "Oops",
        description: "\n      <p>\n        The ${0} eGift card is temporarily sold out. We restock frequently so come back in a little\n        while or choose another eGift card value.\n      </p>\n    "
    };
    var iconTags = {
        skuTagTitle: skuPresentation === null || skuPresentation === void 0 ? void 0 : skuPresentation.skuTagTitle,
        skuIconTags: skuPresentation === null || skuPresentation === void 0 ? void 0 : skuPresentation.skuIconTags
    };
    var stepMappings = {
        0: "choose_step",
        1: "wrap_step",
        2: "send_step",
        3: "preview_step",
        4: "pay_step"
    };
    var ref26 = (0,_sliced_to_array/* default */.Z)((0,CardCustomisationReducer/* useCardCustomisationReducer */.tH)(sku), 2), cardCustomisationState = ref26[0], dispatchCardCustomisationAction = ref26[1];
    var userUploadedDesignFileInput = (0,react.useRef)(null);
    var handleInvalidValuePopupDismiss = function() {
        return setInvalidValuePopupVisible(false);
    };
    var isMultiPurchase = (0,util/* isMultiPurchaseFF */.GI)(sku.multiPurchase, configs.multiPurchaseToggle, user);
    var isLayer = false;
    if (configs.featureLayerBuyingWeb) {
        if (sku.layerEnabled) {
            if (sku.layerType === "default") isLayer = true;
            if (sku.layerType === "upgrade") isLayer = hasUpgradedZag;
        }
    }
    var handleStepToggle = function(step) {
        return function() {
            var newStep;
            var previousStep = stepMappings[state === null || state === void 0 ? void 0 : state.step];
            switch(step){
                case "Choose":
                    newStep = purchaseForm_model/* STEP.CHOOSE */.g.CHOOSE;
                    checkoutStepViewed({
                        purchase_instance_id: purchaseInstanceId,
                        previous_step: previousStep,
                        step: 1,
                        step_name: "choose_step"
                    });
                    break;
                case "Wrap":
                    newStep = purchaseForm_model/* STEP.WRAP */.g.WRAP;
                    break;
                case "Send":
                    newStep = purchaseForm_model/* STEP.SEND */.g.SEND;
                    break;
                case "Preview":
                    newStep = purchaseForm_model/* STEP.PREVIEW */.g.PREVIEW;
                    break;
                case "Pay":
                    newStep = purchaseForm_model/* STEP.PAY */.g.PAY;
                    break;
            }
            dispatch({
                type: ProductPageReducer/* ActionType.SetStep */.Us.SetStep,
                payload: newStep
            });
            dispatch({
                type: ProductPageReducer/* ActionType.SetPreviousStep */.Us.SetPreviousStep,
                payload: previousStep
            });
        };
    };
    var pickRef = (0,react.useRef)(null);
    var wrapRef = (0,react.useRef)(null);
    var sendRef = (0,react.useRef)(null);
    var previewRef = (0,react.useRef)(null);
    var payRef = (0,react.useRef)(null);
    var recipient = (0,ProductPageHelpers/* getRecipientDetails */.x1)(state.formValues, user);
    var isMultiRecipient = state.formValues.recipients.length > 1;
    var steps = {
        Choose: {
            subtitle: "".concat(symbol).concat(formValues.value.replace(/\.00/g, ""), ", for ").concat((formValues === null || formValues === void 0 ? void 0 : formValues.purchaseType) === "self" ? "myself" : "someone else"),
            disabled: state.checkoutState === ProductPageReducer/* CheckoutState.Submitting */.Xw.Submitting,
            hidden: state.step !== purchaseForm_model/* STEP.CHOOSE */.g.CHOOSE,
            component: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(store_PickSection, {
                preselectedValue: preselectedValueExists ? formattedPreselectedValue : undefined
            }),
            ref: pickRef,
            index: purchaseForm_model/* STEP.CHOOSE */.g.CHOOSE
        },
        Wrap: {
            subtitle: (0,ProductPageHelpers/* getWrapSubtitle */.Bp)(formValues),
            disabled: state.step < purchaseForm_model/* STEP.WRAP */.g.WRAP || state.step > purchaseForm_model/* STEP.WRAP */.g.WRAP && formValues.purchaseType === "self" || state.checkoutState === ProductPageReducer/* CheckoutState.Submitting */.Xw.Submitting,
            hidden: state.step > purchaseForm_model/* STEP.WRAP */.g.WRAP && formValues.purchaseType === "friend",
            component: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(WrapSection, {}),
            ref: wrapRef,
            index: purchaseForm_model/* STEP.WRAP */.g.WRAP
        },
        Send: {
            subtitle: recipient ? "For ".concat(recipient) : "",
            disabled: state.step < purchaseForm_model/* STEP.SEND */.g.SEND || state.step > purchaseForm_model/* STEP.SEND */.g.SEND && !!user && ((ref3 = state.formValues) === null || ref3 === void 0 ? void 0 : ref3.purchaseType) === "self" || state.checkoutState === ProductPageReducer/* CheckoutState.Submitting */.Xw.Submitting,
            hidden: state.step > purchaseForm_model/* STEP.SEND */.g.SEND && (!user && ((ref4 = state.formValues) === null || ref4 === void 0 ? void 0 : ref4.purchaseType) === "self" || ((ref5 = state.formValues) === null || ref5 === void 0 ? void 0 : ref5.purchaseType) === "friend"),
            component: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(DeliverSection, {}),
            ref: sendRef,
            index: purchaseForm_model/* STEP.SEND */.g.SEND
        },
        Preview: {
            subtitle: undefined,
            hidden: state.step > purchaseForm_model/* STEP.PREVIEW */.g.PREVIEW,
            disabled: state.step < purchaseForm_model/* STEP.PREVIEW */.g.PREVIEW || state.checkoutState === ProductPageReducer/* CheckoutState.Submitting */.Xw.Submitting,
            component: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(PreviewSection, {}),
            ref: previewRef,
            index: purchaseForm_model/* STEP.PREVIEW */.g.PREVIEW
        },
        Pay: {
            subtitle: undefined,
            hidden: false,
            disabled: state.step !== purchaseForm_model/* STEP.PAY */.g.PAY,
            component: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(PaymentSummary, {}),
            ref: payRef,
            index: purchaseForm_model/* STEP.PAY */.g.PAY
        }
    };
    var guestSelfSteps = [
        "Choose",
        "Send",
        "Preview",
        "Pay"
    ];
    var userSelfSteps = [
        "Choose",
        "Preview",
        "Pay"
    ];
    var friendSteps = [
        "Choose",
        "Wrap",
        "Send",
        "Preview",
        "Pay"
    ];
    var checkoutSteps = ((ref6 = state.formValues) === null || ref6 === void 0 ? void 0 : ref6.purchaseType) === "self" ? user ? userSelfSteps : guestSelfSteps : ((ref7 = state.formValues) === null || ref7 === void 0 ? void 0 : ref7.purchaseType) === "friend" ? friendSteps : Object.keys(steps);
    (0,react.useEffect)(function() {
        productViewed(sku, purchaseInstanceId);
        setInvalidValuePopupVisible(preselectedValueQuery && !preselectedValueExists);
    }, []);
    (0,react.useEffect)(function() {
        if (state.step === purchaseForm_model/* STEP.SEND */.g.SEND && user && state.formValues.purchaseType === "self") {
            var ref;
            checkoutStepCompleted({
                journey: "send_now",
                recipient_count: formValues.purchaseType === "friend" ? (formValues === null || formValues === void 0 ? void 0 : (ref = formValues.recipients) === null || ref === void 0 ? void 0 : ref.length) || 1 : 1,
                purchase_instance_id: purchaseInstanceId,
                step: 3,
                step_name: "send_step"
            });
            dispatch({
                type: ProductPageReducer/* ActionType.SetStep */.Us.SetStep,
                payload: purchaseForm_model/* STEP.PREVIEW */.g.PREVIEW
            });
        }
    }, [
        user
    ]);
    (0,react.useEffect)(function() {
        var currentStepElement = null;
        switch(state.step){
            case purchaseForm_model/* STEP.CHOOSE */.g.CHOOSE:
                currentStepElement = pickRef.current;
                break;
            case purchaseForm_model/* STEP.WRAP */.g.WRAP:
                currentStepElement = wrapRef.current;
                break;
            case purchaseForm_model/* STEP.SEND */.g.SEND:
                currentStepElement = sendRef.current;
                break;
            case purchaseForm_model/* STEP.PREVIEW */.g.PREVIEW:
                currentStepElement = previewRef.current;
                break;
            case purchaseForm_model/* STEP.PAY */.g.PAY:
                currentStepElement = payRef.current;
        }
        if (currentStepElement && !isFirstRender) {
            var ref, ref1;
            var headerOffset = ((ref1 = (ref = document.querySelector("header")) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect()) === null || ref1 === void 0 ? void 0 : ref1.height) || 0;
            var newScroll = currentStepElement.getBoundingClientRect().top + window.scrollY - headerOffset;
            window.scrollTo({
                top: newScroll,
                behavior: "smooth"
            });
        }
    }, [
        state.step
    ]);
    //reset promocode on value change
    var valueSelected = (ref8 = state.formValues) === null || ref8 === void 0 ? void 0 : ref8.value;
    var resetPromo = function() {
        dispatch({
            type: ProductPageReducer/* ActionType.SetFormValues */.Us.SetFormValues,
            payload: {
                promo: null
            }
        });
    };
    (0,react.useEffect)(function() {
        resetPromo();
    }, [
        valueSelected
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            (skuPresentation === null || skuPresentation === void 0 ? void 0 : skuPresentation.seoMeta) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SeoMeta/* default */.Z, {
                meta: skuPresentation.seoMeta
            }) : null,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(ProductPageContext/* ProductPageContext.Provider */.G.Provider, {
                value: {
                    sku: sku,
                    currency: currency,
                    state: state,
                    configs: configs,
                    dispatch: dispatch,
                    isLayer: isLayer,
                    isMultiPurchase: isMultiPurchase,
                    purchaseInstanceId: purchaseInstanceId,
                    personalisedMessages: personalisedMessages,
                    giftThemes: giftThemes,
                    cardCustomisationState: cardCustomisationState,
                    dispatchCardCustomisationAction: dispatchCardCustomisationAction,
                    userUploadedDesignFileInput: userUploadedDesignFileInput,
                    setHasUpgradedZag: setHasUpgradedZag
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ProductSchemaMarkup, {
                        sku: sku
                    }),
                    !state.orderResult ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(react.Fragment, {
                        children: [
                            !preselectedValueExists && invalidValuePopupVisible && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(AlertBox, {
                                heading: preselectValueWarnings.heading,
                                text: preselectValueWarnings.description.replace(util/* Replacement.Zero */.L6.Zero, formattedPreselectedValue),
                                isVisible: invalidValuePopupVisible,
                                dismissHandler: handleInvalidValuePopupDismiss,
                                timeout: 7000
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(PaypalCancelledModal, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Container/* default */.Z, {
                                maxW: "container.md",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Box["default"], {
                                    display: "flex",
                                    gap: {
                                        base: "16px",
                                        xl: "70px"
                                    },
                                    justifyContent: "center",
                                    flexDirection: {
                                        base: "column",
                                        lg: "row"
                                    },
                                    pb: 70,
                                    px: {
                                        base: "10px",
                                        lg: "70px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(store_CardSummary, {
                                            iconTags: iconTags,
                                            zagBuyingPrompt: zagBuyingPrompt
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Box["default"], {
                                            display: "flex",
                                            w: {
                                                base: "100%",
                                                lg: "50%"
                                            },
                                            flexDirection: "column",
                                            mt: {
                                                base: "16px",
                                                lg: "70px"
                                            },
                                            children: [
                                                configs.featureLayerBuyingWeb && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                                                    children: [
                                                        (sku === null || sku === void 0 ? void 0 : sku.layerEnabled) && (sku === null || sku === void 0 ? void 0 : sku.layerType) === "upgrade" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(zag_ZagUpgradeWrapper, {}),
                                                        width > 986 && (sku === null || sku === void 0 ? void 0 : sku.layerEnabled) && (sku === null || sku === void 0 ? void 0 : sku.layerType) === "default" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(zag_ZagBuyingPrompt, {
                                                            imageUrl: zagBuyingPrompt === null || zagBuyingPrompt === void 0 ? void 0 : (ref9 = zagBuyingPrompt.elements) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.image) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.value) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[0]) === null || ref12 === void 0 ? void 0 : ref12.url,
                                                            title: zagBuyingPrompt === null || zagBuyingPrompt === void 0 ? void 0 : (ref13 = zagBuyingPrompt.elements) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.title) === null || ref14 === void 0 ? void 0 : ref14.value,
                                                            description: zagBuyingPrompt === null || zagBuyingPrompt === void 0 ? void 0 : (ref15 = zagBuyingPrompt.elements) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.description) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.value) === null || ref17 === void 0 ? void 0 : ref17.replace("{0}", sku.name),
                                                            modalLinkText: zagBuyingPrompt === null || zagBuyingPrompt === void 0 ? void 0 : (ref18 = zagBuyingPrompt.elements) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.zag_explanation_modal_link) === null || ref19 === void 0 ? void 0 : ref19.value
                                                        })
                                                    ]
                                                }),
                                                checkoutSteps.map(function(key) {
                                                    var ref;
                                                    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm.jsx)(store_AccordionStep, {
                                                        ref: (ref = steps[key]) === null || ref === void 0 ? void 0 : ref.ref,
                                                        title: key,
                                                        subtitle: steps[key].subtitle,
                                                        stepIndex: steps[key].index,
                                                        currentStep: state.step,
                                                        furthestStep: state.furthestStep,
                                                        disabled: steps[key].disabled,
                                                        hidden: steps[key].hidden,
                                                        onToggle: handleStepToggle(key),
                                                        children: steps[key].component
                                                    }, key);
                                                }),
                                                isLayer ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(react.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ZagCardDetails, {}),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RetailerTnCModal, {})
                                                    ]
                                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(react.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(FullCardDetails, {}),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RetailerTnCModal, {})
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            sku.promos.length > 0 ? sku.promos.map(function(promo) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(PromoModal, {
                                    promo: promo
                                }, promo.uid);
                            }) : null,
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(store_CustomCardDesign, {})
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SuccessView, {
                        // @ts-ignore
                        orderNumber: state.orderResult.orderNumber,
                        status: state.orderResult.status,
                        purchaseType: state.formValues.purchaseType === "friend" ? "Friend" : "Self",
                        recipientName: (0,ProductPageHelpers/* getRecipientDetails */.x1)(state.formValues, user),
                        isLoggedin: !!user,
                        isMultiRecipient: isMultiRecipient,
                        guestEmail: state.formValues.guestEmail,
                        guestFirstName: state.formValues.guestFirstName,
                        guestLastName: state.formValues.guestLastName,
                        isLayer: isLayer
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var store_ProductPage = (ProductPage);

// EXTERNAL MODULE: ./node_modules/rescript-classnames/src/Cn.bs.js
var Cn_bs = __webpack_require__(20859);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./src/components/library/Button.bs.js
var Button_bs = __webpack_require__(59037);
// EXTERNAL MODULE: ./src/models/Models.bs.js
var Models_bs = __webpack_require__(37698);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_dict.js
var js_dict = __webpack_require__(43437);
// EXTERNAL MODULE: ./src/bindings/Segment.bs.js + 1 modules
var Segment_bs = __webpack_require__(73840);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_obj.js
var caml_obj = __webpack_require__(84445);
// EXTERNAL MODULE: ./src/components/pages/store/Category.bs.js
var Category_bs = __webpack_require__(80853);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_option.js
var js_option = __webpack_require__(30862);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_string.js
var js_string = __webpack_require__(37712);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
// EXTERNAL MODULE: ./src/components/library/CardStyles.bs.js
var CardStyles_bs = __webpack_require__(70279);
;// CONCATENATED MODULE: ./src/components/library/RemoteCard.tsx



// @ts-ignore
var RemoteSkuTile = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 263).then(__webpack_require__.t.bind(__webpack_require__, 20263, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20263)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {});
    },
    ssr: false
});
var SkuTileContainer = dynamic_default()(function() {
    return(// @ts-ignore using HeroBannerContainer from consumer_woc to provide theme to SkuTile as it does the stuff we want. TODO: Fix this, consumer-ui to be it's own MFE
    __webpack_require__.e(/* import() */ 9963).then(__webpack_require__.t.bind(__webpack_require__, 89963, 23)).then(function(m) {
        return m.HeroBannerContainer;
    }));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89963)
            ];
        }
    },
    ssr: false
});
var Card = function(param) {
    var _card = param.card, themes = _card.themes, promos = _card.promos, tagline = _card.tagline, displayName = _card.displayName, slug = _card.slug, _inGrid = param.inGrid, inGrid = _inGrid === void 0 ? true : _inGrid;
    var ref;
    var href = "/store/".concat(slug, "/");
    var imgSrc = themes === null || themes === void 0 ? void 0 : (ref = themes[0]) === null || ref === void 0 ? void 0 : ref.image;
    var hasPromos = promos === null || promos === void 0 ? void 0 : promos.some(function(promo) {
        return promo.enabled;
    });
    var tags = tagline ? [
        tagline
    ] : [];
    var title = displayName;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        className: inGrid ? CardStyles_bs/* gridContainer */.Uj : "",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SkuTileContainer, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(RemoteSkuTile, {
                // @ts-ignore
                title: title,
                imgSrc: imgSrc,
                imgAlt: title,
                href: href,
                ribbon: hasPromos,
                tags: tags,
                height: "100%"
            })
        })
    });
};
/* harmony default export */ var RemoteCard = (Card);

;// CONCATENATED MODULE: ./src/components/library/RemoteCard.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var make = RemoteCard;
 /* make Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_option.js
var caml_option = __webpack_require__(25400);
// EXTERNAL MODULE: ./src/components/library/SearchInput.bs.js
var SearchInput_bs = __webpack_require__(83651);
// EXTERNAL MODULE: ./src/components/library/FilterButton.bs.js
var FilterButton_bs = __webpack_require__(46703);
// EXTERNAL MODULE: ./src/config/Localization.bs.js
var Localization_bs = __webpack_require__(98765);
// EXTERNAL MODULE: ./src/config/CategoriesConf.bs.js
var CategoriesConf_bs = __webpack_require__(20086);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/list.js
var list = __webpack_require__(62494);
// EXTERNAL MODULE: ./src/components/CardZoomAnimation.bs.js
var CardZoomAnimation_bs = __webpack_require__(12054);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/store/CountryFlagButton.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE






var prodDomains = {
    hd: [
        "au",
        "https://www.prezzee.com.au"
    ],
    tl: {
        hd: [
            "us",
            "https://www.prezzee.com"
        ],
        tl: {
            hd: [
                "uk",
                "https://www.prezzee.uk"
            ],
            tl: {
                hd: [
                    "nz",
                    "https://www.prezzee.co.nz"
                ],
                tl: /* [] */ 0
            }
        }
    }
};
var stgDomains = {
    hd: [
        "au",
        "https://stg.prezzee.com.au"
    ],
    tl: {
        hd: [
            "us",
            "https://stg.prezzee.com"
        ],
        tl: {
            hd: [
                "uk",
                "https://stg.prezzee.uk"
            ],
            tl: {
                hd: [
                    "nz",
                    "https://stg.prezzee.co.nz"
                ],
                tl: /* [] */ 0
            }
        }
    }
};
var isStg = "https://www.prezzee.com.au/".includes("stg");
function CountryFlagButton(props) {
    var category = props.category;
    var getLink = function getLink(param) {
        var match = category.slug;
        switch(match){
            case "au-cards":
                if (isStg) {
                    return list/* assoc */.yG("au", stgDomains);
                } else {
                    return list/* assoc */.yG("au", prodDomains);
                }
            case "nz-cards":
                if (isStg) {
                    return list/* assoc */.yG("nz", stgDomains);
                } else {
                    return list/* assoc */.yG("nz", prodDomains);
                }
            case "uk-cards":
                if (isStg) {
                    return list/* assoc */.yG("uk", stgDomains);
                } else {
                    return list/* assoc */.yG("uk", prodDomains);
                }
            case "us-cards":
                if (isStg) {
                    return list/* assoc */.yG("us", stgDomains);
                } else {
                    return list/* assoc */.yG("us", prodDomains);
                }
            default:
                return "";
        }
    };
    return jsx_runtime.jsx(CardZoomAnimation_bs/* make */.S, {
        children: jsx_runtime.jsx("div", {
            children: jsx_runtime.jsx("a", {
                children: jsx_runtime.jsxs("div", {
                    children: [
                        jsx_runtime.jsx("div", {
                            children: jsx_runtime.jsx((image_default()), {
                                src: category.img,
                                alt: category.name,
                                width: 200,
                                height: 200,
                                className: ""
                            }),
                            className: Cn_bs/* make */.S([
                                "rounded-full h-10 w-10 border-white-smoke border-0 mb-3 flex items-center justify-center mx-auto shadow-light"
                            ])
                        }),
                        jsx_runtime.jsx("p", {
                            children: util_bs/* ReactStuff.s */.p_.s(category.name),
                            className: Cn_bs/* make */.S([
                                "text-center text-dark-gray text-sm"
                            ])
                        })
                    ]
                }),
                className: "cursor-pointer",
                href: getLink(category.slug),
                target: "_blank"
            })
        }, category.name)
    });
}
var Img;
var CountryFlagButton_bs_make = CountryFlagButton;
 /* isStg Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/store/CountriesFilter.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function CountriesFilter(props) {
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx("h3", {
                children: util_bs/* ReactStuff.s */.p_.s("Shopping for someone overseas?"),
                className: "text-15px ml-4"
            }),
            jsx_runtime.jsxs("div", {
                children: [
                    belt_Array/* mapWithIndex */.Su(props.countryCategories, function(i, category) {
                        return jsx_runtime.jsx("div", {
                            children: jsx_runtime.jsx(CountryFlagButton_bs_make, {
                                category: category
                            }),
                            className: "w-1/4 sm:w-1/3 mb-3 md:mb-0"
                        }, "country-" + String(i));
                    }),
                    jsx_runtime.jsx("div", {
                        className: "w-1/4 sm:hidden"
                    })
                ],
                className: "flex w-full justify-around mt-2"
            })
        ],
        className: props.className
    });
}
var CountriesFilter_bs_make = CountriesFilter;
 /* Util Not a pure module */ 

// EXTERNAL MODULE: ./src/components/pages/store/CategoriesFilter.bs.js + 1 modules
var CategoriesFilter_bs = __webpack_require__(93470);
// EXTERNAL MODULE: ./src/components/library/BrazeContentCards.bs.js
var BrazeContentCards_bs = __webpack_require__(85663);
// EXTERNAL MODULE: ./src/components/library/CardSearchResults.bs.js
var CardSearchResults_bs = __webpack_require__(25843);
// EXTERNAL MODULE: ./src/components/pages/store/WallOfCardsStyles.bs.js
var WallOfCardsStyles_bs = __webpack_require__(54098);
// EXTERNAL MODULE: ./src/components/enrichedTextSection/EnrichedTextSection.bs.js + 4 modules
var EnrichedTextSection_bs = __webpack_require__(94135);
// EXTERNAL MODULE: ./src/common/storeSmartCardContent.tsx + 1 modules
var storeSmartCardContent = __webpack_require__(31290);
;// CONCATENATED MODULE: ./src/components/pages/store/WallOfCards.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE






























function inventoryToCards(inventory) {
    return Belt_Array.map(inventory.skus, Models.Card.skuToCard);
}
function getCategoryPosition(card, category) {
    return belt_Option/* mapWithDefault */.k7(belt_Array/* getBy */.ih(card.categories, function(s) {
        return s.slug === category;
    }), 0, function(c) {
        return c.skuPosition;
    });
}
function filterCards(cards, category) {
    return belt_Array/* keep */.Cn(cards, function(sku) {
        var cats = belt_Array/* map */.UI(sku.categories, function(c) {
            return c.slug;
        });
        return belt_Array/* reduce */.u4(cats, false, function(acc, cat) {
            if (acc) {
                return true;
            } else {
                return category.slug === cat;
            }
        });
    }).sort(function(card1, card2) {
        var pos1 = getCategoryPosition(card1, category.slug);
        var pos2 = getCategoryPosition(card2, category.slug);
        if (pos1 > pos2) {
            return 1;
        } else {
            return -1;
        }
    });
}
function getCardLists(param) {
    var cards = param.cards;
    var category = param.category;
    var allCards = caml_obj/* equal */.Dg(category, CategoriesConf_bs/* all */.$6) ? cards : filterCards(cards, category);
    return CardSearchResults_bs/* getCardLists */.We(param.search, allCards);
}
function removeHiddenCards(cards) {
    return cards.filter(function(card) {
        return !card.isPcCategoryHidden;
    });
}
function WallOfCards(props) {
    var topContent = props.topContent;
    var storeContent = props.storeContent;
    var category = props.category;
    var categories = props.categories;
    var inventoryProps = props.inventoryProps;
    var category$1 = category !== undefined ? category : CategoriesConf_bs/* all */.$6;
    var defaultStoreContent_smart_card_content = [];
    var defaultStoreContent = {
        smart_card_content: defaultStoreContent_smart_card_content,
        retailer_card_content: undefined,
        end_of_page_content: undefined
    };
    var storeContentDef;
    if (storeContent !== undefined) {
        var c = caml_option/* valFromOption */.xt(storeContent);
        storeContentDef = c !== undefined ? c : defaultStoreContent;
    } else {
        storeContentDef = defaultStoreContent;
    }
    var categoryName = category$1.slug === "all" && !js_option/* isNone */.Wi(storeContentDef.retailer_card_content) ? jsx_runtime.jsx(EnrichedTextSection_bs/* make */.Sy, {
        block: js_option/* getExn */.BP(storeContentDef.retailer_card_content),
        wallOfCards: true
    }) : jsx_runtime.jsx("h1", {
        children: util_bs/* ReactStuff.s */.p_.s(category$1.name),
        className: WallOfCardsStyles_bs/* title */.TN
    });
    var smartCardHero = storeSmartCardContent/* getSmartCardHeroSection */.Xi(storeContentDef.smart_card_content);
    var smartCardStoreContent = storeContentDef.smart_card_content.length === 0 ? jsx_runtime.jsxs(jsx_runtime.Fragment, {
        children: [
            jsx_runtime.jsx("h2", {
                children: util_bs/* ReactStuff.s */.p_.s("Prezzee Smart eGift Cards"),
                className: WallOfCardsStyles_bs/* title */.TN
            }),
            jsx_runtime.jsxs("h3", {
                children: [
                    util_bs/* ReactStuff.s */.p_.s("For the ultimate shopping spree wrapped up in one great eGift Card, send a Prezzee Smart eGift Card. It's the ideal swap card that lets your recipient turn it into all the big brand retailer cards. "),
                    belt_Option/* mapWithDefault */.k7(Localization_bs/* getLocalizedString */.Z("Personalise"), null, util_bs/* ReactStuff.s */.p_.s),
                    util_bs/* ReactStuff.s */.p_.s(" it with your own photo and a video message. Perfect gift done!")
                ],
                className: WallOfCardsStyles_bs/* description */.WL
            })
        ]
    }) : storeSmartCardContent/* getEnrichedTextSection */.Nn(storeContentDef.smart_card_content);
    var endOfPageStoreContent = js_option/* isNone */.Wi(storeContentDef.end_of_page_content) ? null : jsx_runtime.jsx(EnrichedTextSection_bs/* make */.Sy, {
        block: js_option/* getExn */.BP(storeContentDef.end_of_page_content),
        wallOfCards: true
    });
    var isAllCategory = category$1.slug === "all";
    var router = next_router.useRouter();
    var searchTerm = js_dict/* get */.U2(router.query, "search");
    var searchTimeoutId = {
        contents: setTimeout(function(param) {}, 0)
    };
    var match = react.useState(function() {
        return true;
    });
    var setFirstload = match[1];
    var firstLoad = match[0];
    var currentInventoryProps = isAllCategory ? removeHiddenCards(inventoryProps) : inventoryProps;
    var topContentBlock;
    if (topContent !== undefined) {
        var c$1 = caml_option/* valFromOption */.xt(topContent);
        topContentBlock = c$1 !== undefined ? jsx_runtime.jsx(EnrichedTextSection_bs/* make */.Sy, {
            block: c$1,
            wallOfCards: true
        }) : null;
    } else {
        topContentBlock = null;
    }
    var match$1 = react.useState(function() {
        return belt_Option/* map */.UI(searchTerm, function(s) {
            var str = decodeURIComponent(s);
            return js_string/* replaceByRe */.jt(/([^\w\s\d])/g, "\\$1", str);
        });
    });
    var search = match$1[0];
    var noSearchWords = belt_Option/* getWithDefault */.tj(search, "") === "";
    var match$2 = react.useState(function() {
        return getCardLists({
            search: search,
            category: category$1,
            cards: currentInventoryProps
        });
    });
    var setCardLists = match$2[1];
    var cardLists = match$2[0];
    var allSwapCards = belt_Array/* keepMap */.fe(currentInventoryProps, function(card) {
        if (card.isSwappable) {
            return card;
        }
    });
    var otherCards = belt_Array/* keepMap */.fe(currentInventoryProps, function(card) {
        if (!card.isSwappable) {
            return card;
        }
    });
    var match$3 = react.useState(function() {
        return false;
    });
    var morePanelOpen = match$3[0];
    var match$4 = react.useState(function() {
        return false;
    });
    var toggleFilterPanel = match$4[1];
    var filterPanelOpen = match$4[0];
    var openFilterPanel = function openFilterPanel(param) {
        curry._1(toggleFilterPanel, function(param) {
            return true;
        });
    };
    react.useEffect(function() {
        curry._1(setFirstload, function(param) {
            return false;
        });
    }, []);
    react.useEffect(function() {
        curry._1(toggleFilterPanel, function(param) {
            return false;
        });
        var lists = getCardLists({
            search: search,
            category: category$1,
            cards: currentInventoryProps
        });
        var filteredCards = belt_Array/* keep */.Cn(lists.filteredCards, function(c) {
            if (belt_Array/* some */.G(belt_Array/* map */.UI(c.categories, function(g) {
                return g.name;
            }), function(x) {
                return x === category$1.name;
            })) {
                return true;
            } else {
                return category$1.slug === "all";
            }
        });
        var products = belt_Array/* mapWithIndex */.Su(filteredCards, Segment_bs/* cardToProductWithIndex */.bC);
        curry._1(setCardLists, function(param) {
            return lists;
        });
        searchTimeoutId.contents = setTimeout(function(param) {
            var isHomeSearch = belt_Option/* isSome */.pC(searchTerm) && firstLoad;
            if (belt_Option/* getWithDefault */.tj(search, "").length > 0) {
                Segment_bs/* productsSearched */.l$({
                    query: search,
                    search_count: filteredCards.length,
                    products: products,
                    search_location: isHomeSearch ? "home" : "store"
                });
            }
            if (allSwapCards.length !== 0 && belt_Option/* getWithDefault */.tj(search, "") === "" && category$1.slug === "all") {
                var products$1 = belt_Array/* mapWithIndex */.Su(allSwapCards, Segment_bs/* cardToProductWithIndex */.bC);
                Segment_bs/* productListViewed */.ZX({
                    list_id: "catalogue-promo",
                    category: "Featured",
                    products: products$1
                });
            }
            if (lists.filteredCards.length !== 0) {
                return Segment_bs/* productListViewed */.ZX({
                    list_id: "catalogue-main",
                    category: category$1.name,
                    products: products
                });
            }
        }, 1000);
        return function(param) {
            clearTimeout(searchTimeoutId.contents);
        };
    }, [
        category$1,
        search
    ]);
    var hasSwapCards = allSwapCards.length !== 0;
    var hasCards = cardLists.filteredCards.length !== 0;
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsxs("div", {
                        children: [
                            jsx_runtime.jsx("button", {
                                children: jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                    icon: [
                                        "fas",
                                        "times"
                                    ]
                                }),
                                className: Cn_bs/* make */.S([
                                    Button_bs/* blueCircleStyle */.Yf,
                                    "h-6 w-6 text-white flex items-center justify-center absolute right-0 top-0 z-10 mt-4 mr-4 sm:hidden"
                                ]),
                                onClick: function onClick(e) {
                                    e.preventDefault();
                                    curry._1(toggleFilterPanel, function(param) {
                                        return false;
                                    });
                                }
                            }),
                            jsx_runtime.jsx(CategoriesFilter_bs/* make */.S, {
                                productTypeCategories: categories,
                                selectedCategory: category$1,
                                morePanelOpen: morePanelOpen,
                                toggleMorePanel: match$3[1],
                                className: "w-full my-2 sm:w-4/7 md:w-5/8 lg:w-8/11 xl:w-11/14 xxl:w-13/16"
                            }),
                            jsx_runtime.jsx(CountriesFilter_bs_make, {
                                countryCategories: CategoriesConf_bs/* categoriesByCountry */.HK,
                                className: "w-full my-2 sm:border-l-2 sm:border-t-0 sm:border-b-0 border-gray-200 sm:w-3/7 md:w-3/8 lg:w-3/11 xl:w-3/14 xxl:w-3/16 mx-auto mb-20 sm:mb-0"
                            })
                        ],
                        className: "xl:container sm:flex items-stretch justify-center mx-auto select-none overflow-scroll sm:overflow-visible h-full"
                    }),
                    jsx_runtime.jsxs("div", {
                        children: [
                            jsx_runtime.jsx("div", {
                                children: jsx_runtime.jsx("div", {
                                    children: morePanelOpen ? jsx_runtime.jsx("div", {
                                        children: jsx_runtime.jsx("div", {
                                            children: belt_Array/* mapWithIndex */.Su(categories, function(i, cat) {
                                                var isHiddenAtSize = function isHiddenAtSize(size) {
                                                    return belt_Array/* keep */.Cn(cat.screens, function(c) {
                                                        return c === size;
                                                    }).length === 1;
                                                };
                                                var classes = Cn_bs/* make */.S([
                                                    "w-1/3",
                                                    isHiddenAtSize("xs") ? "xs:hidden" : "",
                                                    isHiddenAtSize("sm") ? "sm:hidden" : "",
                                                    isHiddenAtSize("md") ? "md:hidden" : "",
                                                    isHiddenAtSize("lg") ? "lg:hidden" : "",
                                                    isHiddenAtSize("xl") ? "xl:hidden" : "",
                                                    isHiddenAtSize("xxl") ? "xxl:hidden" : ""
                                                ]);
                                                return jsx_runtime.jsx("div", {
                                                    children: jsx_runtime.jsx(Category_bs/* make */.Sy, {
                                                        category: cat,
                                                        selectedCategory: category$1
                                                    }),
                                                    className: classes
                                                }, "category-" + String(i));
                                            }),
                                            className: "flex flex-wrap p-3 border-0 border-t-1 border-dotted"
                                        }),
                                        className: "absolute right-0 top-0 z-10 border-1 border-t-0 bg-white shadow-lg w-80 rounded-b-md xxl:hidden"
                                    }) : null,
                                    className: "bg-prezzee-red relative"
                                }),
                                className: "sm:w-4/7 md:w-5/8 lg:w-8/11 xl:w-11/14 xxl:w-13/16"
                            }),
                            jsx_runtime.jsx("div", {
                                className: "sm:w-3/7 md:w-3/8 lg:w-3/11 xl:w-3/14 xxl:w-3/16"
                            })
                        ],
                        className: "xl:container lg:flex items-center justify-center mx-auto select-none"
                    })
                ],
                className: Cn_bs/* make */.S([
                    filterPanelOpen ? "overflow-hidden" : "hidden",
                    "fixed w-full h-full z-20 sm:relative sm:block pt-1 mb-4 xl:px-10 bg-white shadow-lg"
                ])
            }),
            jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsxs("div", {
                        children: [
                            jsx_runtime.jsxs("div", {
                                children: [
                                    jsx_runtime.jsx(SearchInput_bs/* make */.Sy, {
                                        setSearch: match$1[1],
                                        defaultValue: belt_Option/* getWithDefault */.tj(searchTerm, ""),
                                        className: "flex-1 relative",
                                        trackSearchReset: function trackSearchReset(param) {
                                            Segment_bs/* customElementInteraction */.pA({
                                                element: "clear_search",
                                                journey: "classic_product_search"
                                            });
                                        }
                                    }),
                                    jsx_runtime.jsx(FilterButton_bs/* make */.S, {
                                        onFilterClick: openFilterPanel
                                    })
                                ],
                                className: "flex flex-nowrap w-full text-gray-600 pt-5 px-2 md:px-4"
                            }),
                            noSearchWords ? jsx_runtime.jsx(BrazeContentCards_bs/* make */.Sy, {}) : null,
                            noSearchWords ? hasSwapCards && hasCards && category$1.slug === "all" ? jsx_runtime.jsxs("div", {
                                children: [
                                    smartCardHero,
                                    smartCardStoreContent,
                                    jsx_runtime.jsx("div", {
                                        children: belt_Array/* mapWithIndex */.Su(allSwapCards, function(i, card) {
                                            return jsx_runtime.jsx(make, {
                                                card: card
                                            }, "eGifCard_" + String(i));
                                        }),
                                        className: WallOfCardsStyles_bs/* cardsContainer */.VV
                                    })
                                ]
                            }) : null : hasSwapCards ? hasCards ? jsx_runtime.jsx("h2", {
                                children: util_bs/* ReactStuff.s */.p_.s("Your search results"),
                                className: WallOfCardsStyles_bs/* title */.TN
                            }) : jsx_runtime.jsxs(jsx_runtime.Fragment, {
                                children: [
                                    jsx_runtime.jsx("h2", {
                                        children: util_bs/* ReactStuff.s */.p_.s("Prezzee Smart eGift Cards"),
                                        className: WallOfCardsStyles_bs/* title */.TN
                                    }),
                                    jsx_runtime.jsx("h3", {
                                        children: util_bs/* ReactStuff.s */.p_.s("Your search has yielded no results. so why not consider the Prezzee Smart eGift Card which can be used to unlock our wall of retailer eGift Cards"),
                                        className: WallOfCardsStyles_bs/* description */.WL
                                    }),
                                    jsx_runtime.jsx("div", {
                                        children: belt_Array/* mapWithIndex */.Su(allSwapCards, function(i, card) {
                                            return jsx_runtime.jsx(make, {
                                                card: card
                                            }, "eGifCard_" + String(i));
                                        }),
                                        className: WallOfCardsStyles_bs/* cardsContainer */.VV
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    jsx_runtime.jsxs(jsx_runtime.Fragment, {
                        children: [
                            belt_Option/* getWithDefault */.tj(search, "").length === 0 ? topContentBlock === null ? categoryName : topContentBlock : null,
                            jsx_runtime.jsx("div", {
                                children: category$1.slug === "all" && belt_Option/* getWithDefault */.tj(search, "") === "" ? belt_Array/* mapWithIndex */.Su(otherCards, function(i, card) {
                                    return jsx_runtime.jsx(make, {
                                        card: card
                                    }, card.uid);
                                }) : belt_Array/* mapWithIndex */.Su(cardLists.filteredCards, function(i, card) {
                                    return jsx_runtime.jsx(make, {
                                        card: card
                                    }, card.uid);
                                }),
                                className: WallOfCardsStyles_bs/* cardsContainer */.VV
                            }),
                            jsx_runtime.jsx("div", {
                                children: jsx_runtime.jsx(CardSearchResults_bs/* SimilarResults.make */.I2.make, {
                                    cardLists: cardLists,
                                    className: "mt-4"
                                }),
                                className: WallOfCardsStyles_bs/* similarResultsContainer */.Ro
                            })
                        ]
                    }),
                    endOfPageStoreContent,
                    noSearchWords ? null : jsx_runtime.jsx(BrazeContentCards_bs/* make */.Sy, {})
                ],
                className: WallOfCardsStyles_bs/* rootContainerWall */.lE
            })
        ],
        className: Cn_bs/* make */.S([
            filterPanelOpen ? "overflow-hidden bg-white" : "",
            "relative bg-white"
        ])
    });
}
var SkuPresentation;
var WallOfCards_bs_make = WallOfCards;
 /* Util Not a pure module */ 

// EXTERNAL MODULE: ./src/api/graphql/StoreCategory/Gql__StoreCategory__Decoder.bs.js
var Gql_StoreCategory_Decoder_bs = __webpack_require__(29160);
;// CONCATENATED MODULE: ./src/components/pages/store/CategoryPage.tsx





var CategoryPage = function(param) {
    var pid = param.pid, inventory = param.inventory, categories = param.categories, storeCategory = param.storeCategory;
    var categoriesPros = (0,CategoriesConf_bs/* catDataToCatConf */._v)(categories.results);
    var category = (0,CategoriesConf_bs/* getCategoryBySlug */.fj)(pid, categoriesPros);
    var storyCategoryData = (0,Gql_StoreCategory_Decoder_bs/* parse */.Qc)(storeCategory);
    var topContent = storyCategoryData === null || storyCategoryData === void 0 ? void 0 : storyCategoryData.top_content;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            (storyCategoryData === null || storyCategoryData === void 0 ? void 0 : storyCategoryData.seo_meta) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SeoMeta/* default */.Z, {
                meta: storyCategoryData === null || storyCategoryData === void 0 ? void 0 : storyCategoryData.seo_meta.VAL
            }) : null,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(WallOfCards_bs_make, {
                inventoryProps: inventory,
                category: category,
                categories: categoriesPros,
                topContent: topContent
            })
        ]
    });
};
/* harmony default export */ var store_CategoryPage = (CategoryPage);

;// CONCATENATED MODULE: ./src/pages/store/[pid].tsx


__webpack_require__(14473);


var _pid_ProductPage = function(props) {
    return !("inventory" in props) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(store_ProductPage, (0,_object_spread/* default */.Z)({}, props)) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(store_CategoryPage, (0,_object_spread/* default */.Z)({}, props));
};
var __N_SSP = true;
/* harmony default export */ var _pid_ = (_pid_ProductPage);


/***/ }),

/***/ 60270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getFingerprint; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _fingerprintjs_fingerprintjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60022);
/* harmony import */ var _fingerprintjs_fingerprintjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_fingerprintjs_fingerprintjs__WEBPACK_IMPORTED_MODULE_0__);



var options = {
    excludes: {
        plugins: true,
        localStorage: true,
        adBlock: true,
        screenResolution: true,
        availableScreenResolution: true,
        enumerateDevices: true,
        pixelRatio: true,
        doNotTrack: true
    }
};
function getFingerprint() {
    return new Promise(function(resolve, reject) {
        function getHash() {
            return _getHash.apply(this, arguments);
        }
        function _getHash() {
            _getHash = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                var components, values, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                _fingerprintjs_fingerprintjs__WEBPACK_IMPORTED_MODULE_0___default().getPromise(options)
                            ];
                        case 1:
                            components = _state.sent();
                            values = components.map(function(component) {
                                return component.value;
                            });
                            return [
                                2,
                                _fingerprintjs_fingerprintjs__WEBPACK_IMPORTED_MODULE_0___default().x64hash128(values.join(""), 31)
                            ];
                        case 2:
                            e = _state.sent();
                            reject(e);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return _getHash.apply(this, arguments);
        }
        if (window.requestIdleCallback) {
            requestIdleCallback(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getHash()
                            ];
                        case 1:
                            return [
                                2,
                                resolve.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            }));
        } else {
            setTimeout(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getHash()
                            ];
                        case 1:
                            return [
                                2,
                                resolve.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            }), 500);
        }
    });
}



/***/ }),

/***/ 31290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Nn": function() { return /* binding */ getEnrichedTextSection; },
  "Xi": function() { return /* binding */ getSmartCardHeroSection; }
});

// UNUSED EXPORTS: ContentBlockName

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./src/components/enrichedTextSection/EnrichedTextSection.bs.js + 4 modules
var EnrichedTextSection_bs = __webpack_require__(94135);
// EXTERNAL MODULE: ./node_modules/@emotion/css/dist/emotion-css.esm.js
var emotion_css_esm = __webpack_require__(97133);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/CmsImage.tsx
var CmsImage = __webpack_require__(73450);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/theme/foundations/colors.js
var colors = __webpack_require__(85171);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/theme/foundations/breakpoints.js
var breakpoints = __webpack_require__(72486);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Responsive.bs.js
var Theme_Responsive_bs = __webpack_require__(70965);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Button/Button.bs.js + 1 modules
var Button_bs = __webpack_require__(10573);
;// CONCATENATED MODULE: ./src/components/library/smartCardHeroSection.tsx








var style = {
    container: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("background-color:", colors["default"].lilac[50], ";border-radius:8px;display:flex;align-items:center;justify-content:space-between;margin:0 0 44px;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{align-items:center;flex-direction:column-reverse;padding:0 16px 16px;}"),
    content: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:60%;padding:0 0 0 57px;@media (max-width:", breakpoints["default"].lg, "){width:54%;padding:41px 0 32px 32px;}@media ", Theme_Responsive_bs/* tabletSm */.FV, "{width:100%;padding:0;}"),
    title: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:27px;line-height:32px;font-weight:600;"),
    description: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin-top:12px;"),
    primaryBtn: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("margin:0 12px 0 0;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{margin:0 0 12px 0;}"),
    buttonContainer: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;margin-top:24px;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{flex-flow:column;button{width:100%;}}"),
    image: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:35%;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{display:none;}"),
    mobileImage: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:none;width:100%;@media ", Theme_Responsive_bs/* tabletSm */.FV, "{display:block;}")
};
var SmartCardHeroSection = function(param) {
    var _block = param.block, title = _block.title, description = _block.description, primaryButton = _block.primaryButton, secondaryButton = _block.secondaryButton, image = _block.image, mobileImage = _block.mobileImage;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        className: "".concat(style.container, " mx-4"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: style.content,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("h2", {
                        className: style.title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                        className: style.description,
                        children: description
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                        className: style.buttonContainer,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button_bs.make, {
                                variant: primaryButton.variant,
                                colour: primaryButton.colour,
                                fill: primaryButton.fill,
                                className: style.primaryBtn,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((link_default()), {
                                    href: primaryButton.cta_url,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("a", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                            children: primaryButton.cta_text
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button_bs.make, {
                                variant: secondaryButton.variant,
                                colour: secondaryButton.colour,
                                fill: secondaryButton.fill,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((link_default()), {
                                    href: secondaryButton.cta_url,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("a", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                                            children: secondaryButton.cta_text
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                src: image.url,
                alt: image.description,
                width: image.width,
                height: image.height,
                className: style.image,
                sizes: "".concat(Theme_Responsive_bs/* smallScreenOrMobile */.HH, " 220px, ").concat(Theme_Responsive_bs/* tabletOrMobile */.k$, " 260px, ").concat(Theme_Responsive_bs/* belowLargeScreen */.Qo, " 350px, 500px")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CmsImage/* default */.Z, {
                src: mobileImage.url,
                alt: mobileImage.description,
                width: mobileImage.width,
                height: mobileImage.height,
                className: style.mobileImage,
                sizes: "48vw"
            })
        ]
    });
};
/* harmony default export */ var smartCardHeroSection = (SmartCardHeroSection);

;// CONCATENATED MODULE: ./src/common/storeSmartCardContent.tsx



var ContentBlockName;
(function(ContentBlockName) {
    ContentBlockName["EnrichedTextBlock"] = "EnrichedTextBlock";
    ContentBlockName["SmartCardHeroBlock"] = "SmartCardHeroBlock";
})(ContentBlockName || (ContentBlockName = {}));
var getEnrichedTextSection = function(storeContent) {
    var data = storeContent.find(function(param) {
        var NAME = param.NAME;
        return NAME === ContentBlockName.EnrichedTextBlock;
    });
    return data ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(EnrichedTextSection_bs/* make */.Sy, {
        block: data.VAL,
        wallOfCards: true
    }) : null;
};
var getSmartCardHeroSection = function(storeContent) {
    var data = storeContent.find(function(param) {
        var NAME = param.NAME;
        return NAME === ContentBlockName.SmartCardHeroBlock;
    });
    return data ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(smartCardHeroSection, {
        block: data.VAL
    }) : null;
};


/***/ }),

/***/ 85663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports ContentCard, TopContainer, BottomContainer, Title, Description, DeviceSizeImage, Carousel, Slide, SlideContent, Styles */
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(92592);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(25400);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48929);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_components_common_ContentCard_ContentCard_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29627);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17845);
/* harmony import */ var _prezzee_ribbon_src_components_common_DeviceSizeImage_DeviceSizeImage_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81343);
/* harmony import */ var _prezzee_ribbon_src_components_common_FullWidthCarousel_FullWidthCarousel_bs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96020);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32567);
/* harmony import */ var _prezzee_ribbon_src_components_common_ContentCard_ContentCard_Title_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53973);
/* harmony import */ var _prezzee_ribbon_src_components_common_ContentCard_ContentCard_Description_bs_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8266);
/* harmony import */ var _prezzee_ribbon_src_components_common_FullWidthCarousel_FullWidthCarousel_Slide_bs_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(29261);
/* harmony import */ var _prezzee_ribbon_src_components_common_ContentCard_ContentCard_TopContainer_bs_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5926);
/* harmony import */ var _prezzee_ribbon_src_components_common_ContentCard_ContentCard_BottomContainer_bs_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70945);
/* harmony import */ var _prezzee_ribbon_src_components_common_FullWidthCarousel_FullWidthCarousel_SlideContent_bs_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(32426);
// Generated by ReScript, PLEASE EDIT WITH CARE



















var image = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .display */ .jfB("block"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .pct */ .hdZ(100)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .borderTopLeftRadius */ .orU(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(8)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .borderTopRightRadius */ .E$t(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(8)),
                tl: /* [] */ 0
            }
        }
    }
});
var description = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TSy, {
    hd: _prezzee_ribbon_src_theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .Styles.style4 */ .z.style4,
    tl: {
        hd: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_prezzee_ribbon_src_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .Business.charcoal */ .e.charcoal),
            tl: /* [] */ 0
        }),
        tl: /* [] */ 0
    }
});
var slide = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .height */ .Cb8("auto")),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .display */ .jfB("flex"),
        tl: /* [] */ 0
    }
});
var slideContent = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .padding2 */ .BLt(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(10), _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(13))),
    tl: /* [] */ 0
});
var $$global = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TSy, {
    hd: _prezzee_ribbon_src_theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_8__/* .Styles.body */ .z.body,
    tl: {
        hd: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .pct */ .hdZ(100)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .important */ .efO(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginTop */ .E9m(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.5))),
                tl: /* [] */ 0
            }
        }),
        tl: /* [] */ 0
    }
});
var Styles = {
    image: image,
    description: description,
    slide: slide,
    slideContent: slideContent,
    $$global: $$global
};
function BrazeContentCards(props) {
    var match = react__WEBPACK_IMPORTED_MODULE_1__.useState(function() {});
    var setCardData = match[1];
    var cardData = match[0];
    var match$1 = react__WEBPACK_IMPORTED_MODULE_1__.useState(function() {
        return 0;
    });
    var setTotalCards = match$1[1];
    var totalCards = match$1[0];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        var timeout = setTimeout(function(param) {
            var hasLoaded = window.appboy !== undefined;
            if (hasLoaded) {
                window.appboy.openSession();
                window.appboy.requestContentCardsRefresh();
                return window.appboy.subscribeToContentCardsUpdates(function(updates) {
                    var cards = updates.cards;
                    var totalCards = cards.length;
                    if (totalCards > 0) {
                        _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(setCardData, function(param) {
                            return cards;
                        });
                        return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_15__._1(setTotalCards, function(param) {
                            return totalCards;
                        });
                    }
                });
            }
        }, 1000);
        return function(param) {
            clearTimeout(timeout);
        };
    }, []);
    var contentCardComponent = cardData !== undefined ? _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_16__/* .mapWithIndex */ .Su(cardData, function(idx, card) {
        var key = String(idx);
        var extras = card.extras;
        var title = card.title;
        if (extras == null) {
            return null;
        }
        var card_type = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .getWithDefault */ .tj(extras.card_type, "");
        var $$location = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .getWithDefault */ .tj(extras.location, "");
        if ($$location !== "wall_of_cards_web") {
            return null;
        }
        if (card_type !== "slider") {
            return null;
        }
        var image_desktop = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .getWithDefault */ .tj(extras.image_desktop, "");
        var image_tablet = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .getWithDefault */ .tj(extras.image_tablet, "");
        var image_mobile = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .getWithDefault */ .tj(extras.image_mobile, "");
        var desktopImage = _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_18__/* .some */ .G(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("img", {
            className: image,
            alt: title,
            src: image_desktop
        }));
        var tabletImage = _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_18__/* .some */ .G(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("img", {
            className: image,
            alt: title,
            src: image_tablet
        }));
        var mobileImage = _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_18__/* .some */ .G(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("img", {
            className: image,
            alt: title,
            src: image_mobile
        }));
        var image$1 = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_common_DeviceSizeImage_DeviceSizeImage_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .make */ .S, {
            desktop: desktopImage,
            smallScreen: tabletImage,
            tablet: undefined,
            mobile: mobileImage
        });
        var slideContent$1 = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_common_FullWidthCarousel_FullWidthCarousel_Slide_bs_js__WEBPACK_IMPORTED_MODULE_11__/* .make */ .Sy, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_common_FullWidthCarousel_FullWidthCarousel_SlideContent_bs_js__WEBPACK_IMPORTED_MODULE_14__/* .make */ .S, {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs(_prezzee_ribbon_src_components_common_ContentCard_ContentCard_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .make */ .S, {
                    children: [
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_common_ContentCard_ContentCard_TopContainer_bs_js__WEBPACK_IMPORTED_MODULE_12__/* .make */ .S, {
                            children: image$1
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs(_prezzee_ribbon_src_components_common_ContentCard_ContentCard_BottomContainer_bs_js__WEBPACK_IMPORTED_MODULE_13__/* .make */ .S, {
                            children: [
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_common_ContentCard_ContentCard_Title_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .make */ .S, {
                                    children: title
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_common_ContentCard_ContentCard_Description_bs_js__WEBPACK_IMPORTED_MODULE_10__/* .make */ .S, {
                                    children: card.description
                                })
                            ]
                        })
                    ]
                }),
                className: slideContent
            })
        });
        var href = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_17__/* .getWithDefault */ .tj(card.url, "");
        var slide$1 = href === "" ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
            children: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_18__/* .some */ .G(slideContent$1)
        }) : react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx("a", {
            children: slideContent$1,
            href: href
        });
        if (totalCards !== 1) {
            return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
                className: slide,
                children: slide$1
            }, key);
        } else {
            return slide$1;
        }
    }) : null;
    if (totalCards !== 0) {
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx(_prezzee_ribbon_src_components_common_FullWidthCarousel_FullWidthCarousel_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .make */ .Sy, {
            children: contentCardComponent,
            autoplay: true,
            className: $$global
        });
    } else {
        return null;
    }
}
var ContentCard;
var TopContainer;
var BottomContainer;
var Title;
var Description;
var DeviceSizeImage;
var Carousel;
var Slide;
var SlideContent;
var make = BrazeContentCards;
 /* image Not a pure module */ 


/***/ }),

/***/ 46703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20859);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92592);
/* harmony import */ var _Button_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59037);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72491);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE





function FilterButton(props) {
    var onFilterClick = props.onFilterClick;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("button", {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("img", {
                className: "h-4 w-4 block mx-auto",
                alt: "search",
                src: "/images/icon-filter.svg"
            }),
            className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S([
                _Button_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .redCircleStyle */ .Gx,
                "sm:hidden flex items-center content-center h-12 w-12 ml-3"
            ]),
            onClick: function onClick(param) {
                _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_3__/* .mapWithDefault */ .k7(onFilterClick, undefined, function(click) {
                    _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__._1(click, undefined);
                });
            }
        }),
        className: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_3__/* .getWithDefault */ .tj(props.className, "")
    });
}
var make = FilterButton;
 /* Button Not a pure module */ 


/***/ }),

/***/ 83651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports Styles, alphaNumbericSearch */
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(20859);
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92592);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Button_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59037);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72491);
/* harmony import */ var _utils_LayoutDataContext_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37110);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Button_Button_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10573);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67814);
// Generated by ReScript, PLEASE EDIT WITH CARE










var clearIcon = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_7__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_Y(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("395fa0")),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(14)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .boxSizing */ .ixg("contentBox"),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingTop */ .odA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(3)),
                tl: /* [] */ 0
            }
        }
    }
});
var resetButton = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_7__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .width */ .bf$(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(3)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingRight */ .WLm(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0.75)),
        tl: /* [] */ 0
    }
});
var Styles = {
    clearIcon: clearIcon,
    resetButton: resetButton
};
function alphaNumbericSearch(str) {
    return str.replace(/[^\w\s]/g, "\\$&");
}
function SearchInput(props) {
    var trackSearchReset = props.trackSearchReset;
    var placeholder = props.placeholder;
    var defaultValue = props.defaultValue;
    var setSearch = props.setSearch;
    var match = react__WEBPACK_IMPORTED_MODULE_1__.useState(function() {
        return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_8__/* .getWithDefault */ .tj(defaultValue, "");
    });
    var setSearchTerm = match[1];
    var searchTerm = match[0];
    var onSearchReset = function onSearchReset(param) {
        _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_7__._1(setSearchTerm, function(param) {
            return "";
        });
        _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_7__._1(setSearch, function(param) {
            return "";
        });
        _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_8__/* .mapWithDefault */ .k7(trackSearchReset, undefined, function(track) {
            _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_7__._1(track, undefined);
        });
    };
    var resetButton$1 = searchTerm.length > 0 ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_prezzee_ribbon_src_components_personal_Button_Button_bs_js__WEBPACK_IMPORTED_MODULE_5__.make, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("button", {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_6__.FontAwesomeIcon, {
                icon: [
                    "fas",
                    "times"
                ],
                className: clearIcon
            }),
            className: "w-full h-full bg-transparent",
            onClick: onSearchReset
        }),
        variant: /* Icon */ 2,
        className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .make */ .S([
            resetButton,
            "h-full absolute top-0 right-0"
        ])
    }) : null;
    var state = _utils_LayoutDataContext_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .useContext */ .qp(undefined);
    var configurablePlaceholder = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        if (state !== undefined && state.searchBarPlaceholder.length > 0) {
            return state.searchBarPlaceholder;
        } else {
            return placeholder;
        }
    }, [
        _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_8__/* .map */ .UI(state, function(c) {
            return c.searchBarPlaceholder;
        }),
        placeholder
    ]);
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs("div", {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("div", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("img", {
                    className: "h-4 w-4 block mx-auto",
                    alt: "search",
                    src: "/images/search.svg"
                }),
                className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_9__/* .make */ .S([
                    _Button_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .redCircleStyle */ .Gx,
                    "flex items-center content-center h-12 w-12 absolute left-0"
                ])
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("input", {
                className: "text-base bg-white h-12 pr-12 pl-16 lg:pl-16 sm:pl-16 outline-none focus:outline-none focus:shadow-sm border border-gray-300 shadow-md w-full rounded-full",
                name: "search",
                placeholder: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_8__/* .getWithDefault */ .tj(configurablePlaceholder, "Search retailers"),
                value: searchTerm,
                onChange: function onChange(e) {
                    var value = e.target.value;
                    var cleanValue = alphaNumbericSearch(value);
                    _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_7__._1(setSearchTerm, function(param) {
                        return value;
                    });
                    _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_7__._1(setSearch, function(param) {
                        return cleanValue;
                    });
                }
            }),
            resetButton$1
        ],
        className: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_8__/* .getWithDefault */ .tj(props.className, "")
    });
}
var make = SearchInput;
 /* clearIcon Not a pure module */ 


/***/ }),

/***/ 93470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ CategoriesFilter_bs_make; }
});

// EXTERNAL MODULE: ./node_modules/rescript-classnames/src/Cn.bs.js
var Cn_bs = __webpack_require__(20859);
// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
// EXTERNAL MODULE: ./src/components/pages/store/Category.bs.js
var Category_bs = __webpack_require__(80853);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_option.js
var caml_option = __webpack_require__(25400);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./src/components/CardZoomAnimation.bs.js
var CardZoomAnimation_bs = __webpack_require__(12054);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/store/CategoryMore.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE






function CategoryMore(props) {
    var toggleMorePanel = props.toggleMorePanel;
    var morePanelOpen = props.morePanelOpen;
    var category = props.category;
    var isSelected = morePanelOpen === true;
    var setSelectedStyle = function setSelectedStyle(checked) {
        return Cn_bs/* make */.S([
            checked ? "border-prezzee-blue text-white" : ""
        ]);
    };
    var setSelectedTextStyle = function setSelectedTextStyle(checked) {
        return Cn_bs/* make */.S([
            checked ? "text-prezzee-blue" : ""
        ]);
    };
    return jsx_runtime.jsx(CardZoomAnimation_bs/* make */.S, {
        children: jsx_runtime.jsx("div", {
            children: jsx_runtime.jsx("div", {
                children: jsx_runtime.jsxs("div", {
                    children: [
                        jsx_runtime.jsx("div", {
                            children: jsx_runtime.jsx((image_default()), {
                                src: category.img,
                                alt: category.name,
                                width: 200,
                                height: 200,
                                className: Cn_bs/* make */.S([
                                    props.iconClassName,
                                    setSelectedStyle(isSelected)
                                ])
                            }),
                            className: Cn_bs/* make */.S([
                                "rounded-full h-10 w-10 p-2 border-white-smoke border-0 mb-3 flex items-center justify-center mx-auto shadow-light",
                                setSelectedStyle(isSelected)
                            ])
                        }),
                        jsx_runtime.jsx("p", {
                            children: util_bs/* ReactStuff.s */.p_.s(category.name),
                            className: Cn_bs/* make */.S([
                                "text-center text-dark-gray text-sm",
                                setSelectedTextStyle(isSelected)
                            ])
                        })
                    ]
                }),
                className: "cursor-pointer",
                htmlFor: category.name,
                onClick: function onClick(param) {
                    curry._1(toggleMorePanel, function(param) {
                        return !morePanelOpen;
                    });
                }
            })
        }, category.name)
    });
}
var Link;
var Img;
var make = CategoryMore;
 /* Util Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_SetString.js + 3 modules
var belt_SetString = __webpack_require__(34847);
// EXTERNAL MODULE: ./src/config/CategoriesConf.bs.js
var CategoriesConf_bs = __webpack_require__(20086);
;// CONCATENATED MODULE: ./src/components/pages/store/CategoriesFilter.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE









function CategoriesFilter(props) {
    var notEmptyCatigories = props.notEmptyCatigories;
    var selectCategory = props.selectCategory;
    var selectedCategory = props.selectedCategory;
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx("h3", {
                children: util_bs/* ReactStuff.s */.p_.s("Browse by category"),
                className: "text-15px ml-4"
            }),
            jsx_runtime.jsxs("div", {
                children: [
                    belt_Array/* mapWithIndex */.Su(props.productTypeCategories, function(i, category) {
                        var isVisibleAtSize = function isVisibleAtSize(size) {
                            return belt_Array/* keep */.Cn(category.screens, function(c) {
                                return c === size;
                            }).length === 1;
                        };
                        var match = category.slug;
                        var disabled = notEmptyCatigories !== undefined && match !== "all" ? !belt_SetString/* has */.e$(caml_option/* valFromOption */.xt(notEmptyCatigories), match) : false;
                        var classes = Cn_bs/* make */.S([
                            "w-1/4 mb-3 md:mb-0 lg:w-1/6 md:w-1/4",
                            isVisibleAtSize("sm") ? "sm:block" : "sm:hidden",
                            isVisibleAtSize("md") ? "md:block" : "",
                            isVisibleAtSize("lg") ? "lg:block" : "",
                            isVisibleAtSize("xl") ? "xl:block" : "",
                            isVisibleAtSize("xxl") ? "xxl:block" : ""
                        ]);
                        if (disabled) {
                            return null;
                        } else {
                            return jsx_runtime.jsx("div", {
                                children: jsx_runtime.jsx(Category_bs/* make */.Sy, {
                                    category: category,
                                    selectedCategory: selectedCategory,
                                    selectCategory: selectCategory,
                                    iconClassName: "select-none",
                                    disabled: disabled
                                }),
                                className: classes
                            }, "category-bis-" + String(i));
                        }
                    }),
                    jsx_runtime.jsx("div", {
                        children: jsx_runtime.jsx(make, {
                            category: CategoriesConf_bs/* more */.Dk,
                            morePanelOpen: props.morePanelOpen,
                            toggleMorePanel: props.toggleMorePanel,
                            iconClassName: "w-5 h-5"
                        }),
                        className: "hidden sm:block xxl:hidden w-1/4 mb-3 md:mb-0 lg:w-1/6 md:w-1/4 "
                    }, "category-none")
                ],
                className: "flex justify-start md:justify-between w-full flex-wrap md:flex-nowrap mt-2 lg:pb-3"
            })
        ],
        className: props.className
    });
}
var CategoriesFilter_bs_make = CategoriesFilter;
 /* Util Not a pure module */ 


/***/ }),

/***/ 80853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports Link, Img */
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20859);
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92592);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72491);
/* harmony import */ var _CardZoomAnimation_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12054);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE








function Category(props) {
    var disabled = props.disabled;
    var iconClassName = props.iconClassName;
    var selectCategory = props.selectCategory;
    var category = props.category;
    var disabled$1 = disabled !== undefined ? disabled : false;
    var isChecked = category.name === props.selectedCategory.name;
    var setCheckedStyle = function setCheckedStyle(checked) {
        return rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .make */ .S([
            checked ? "border-prezzee-blue text-white" : ""
        ]);
    };
    var setCheckedTextStyle = function setCheckedTextStyle(checked) {
        return rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .make */ .S([
            checked ? "text-prezzee-blue" : ""
        ]);
    };
    var getLink = function getLink(slug) {
        if (slug !== "all") {
            return "/store/" + slug;
        } else {
            return "/store/";
        }
    };
    if (selectCategory !== undefined) {
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_CardZoomAnimation_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs("div", {
                children: [
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("input", {
                        className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .make */ .S([
                            "hidden",
                            setCheckedStyle(isChecked)
                        ]),
                        id: category.name,
                        checked: isChecked,
                        name: category.name,
                        type: "radio",
                        value: category.name,
                        onChange: function onChange(param) {
                            if (disabled$1) {
                                return;
                            } else {
                                return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_6__._1(selectCategory, function(param) {
                                    return category;
                                });
                            }
                        }
                    }),
                    react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs("label", {
                        children: [
                            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("div", {
                                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx((next_future_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    src: category.img,
                                    alt: category.name,
                                    width: 200,
                                    height: 200,
                                    className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .make */ .S([
                                        _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_7__/* .getWithDefault */ .tj(iconClassName, ""),
                                        setCheckedStyle(isChecked)
                                    ])
                                }),
                                className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .make */ .S([
                                    category.slug !== "nz-cards" ? "rounded-full h-10 w-10 p-2 border-white-smoke border-0 mb-3 flex items-center justify-center mx-auto shadow-light" : "rounded-full h-10 w-10 border-white-smoke border-0 mb-3 flex items-center justify-center mx-auto shadow-light",
                                    disabled$1 ? "bg-gray-400" : "",
                                    setCheckedStyle(isChecked)
                                ])
                            }),
                            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("p", {
                                children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(category.name),
                                className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .make */ .S([
                                    "text-center text-sm lg:leading-18",
                                    disabled$1 ? "text-gray-500 " : "text-dark-gray",
                                    setCheckedTextStyle(isChecked)
                                ])
                            })
                        ],
                        className: disabled$1 ? "cursor-default" : "cursor-pointer",
                        htmlFor: category.name
                    })
                ]
            }, category.name)
        });
    } else {
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx(_CardZoomAnimation_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("div", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: getLink(category.slug),
                    prefetch: false,
                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("a", {
                        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs("div", {
                            children: [
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("div", {
                                    children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx((next_future_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        src: category.img,
                                        alt: category.name,
                                        width: 200,
                                        height: 200,
                                        className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .make */ .S([
                                            _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_7__/* .getWithDefault */ .tj(iconClassName, ""),
                                            setCheckedStyle(isChecked)
                                        ])
                                    }),
                                    className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .make */ .S([
                                        category.slug !== "nz-cards" ? "rounded-full h-10 w-10 p-2 border-white-smoke border-0 mb-3 flex items-center justify-center mx-auto shadow-light" : "rounded-full h-10 w-10 border-white-smoke border-0 mb-3 flex items-center justify-center mx-auto shadow-light",
                                        setCheckedStyle(isChecked)
                                    ])
                                }),
                                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx("p", {
                                    children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s(category.name),
                                    className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .make */ .S([
                                        "text-center text-dark-gray text-sm lg:leading-18",
                                        setCheckedTextStyle(isChecked)
                                    ])
                                })
                            ]
                        }),
                        className: "cursor-pointer"
                    })
                })
            }, category.name)
        });
    }
}
var Link$1;
var Img;
var make = Category;
 /* Util Not a pure module */ 


/***/ }),

/***/ 54098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ro": function() { return /* binding */ similarResultsContainer; },
/* harmony export */   "TN": function() { return /* binding */ title; },
/* harmony export */   "VV": function() { return /* binding */ cardsContainer; },
/* harmony export */   "WL": function() { return /* binding */ description; },
/* harmony export */   "lE": function() { return /* binding */ rootContainerWall; }
/* harmony export */ });
/* unused harmony export aboutGrid */
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92592);
// Generated by ReScript, PLEASE EDIT WITH CARE


var similarResultsContainer = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_1__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .selector */ .nZE("> h3", {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginLeft */ .oIA(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0.8)),
        tl: /* [] */ 0
    }),
    tl: /* [] */ 0
});
var rootContainerWall = "container mx-auto p-0";
var cardsContainer = "flex mt-4 flex-wrap";
var title = "text-2xl sm:text-32px leading-8 font-semibold pt-4 mx-4 pb-2 sm:pb-3";
var description = "text-base mx-4 text-gray-600";
var aboutGrid = "flex flex-wrap pt-10 -mx-6 text-sm text-gray-600 mx-auto";
 /* similarResultsContainer Not a pure module */ 


/***/ }),

/***/ 16029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ ProductPageContext; },
/* harmony export */   "i": function() { return /* binding */ useProduct; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var ProductPageContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var useProduct = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ProductPageContext);
    if (!context) throw new Error("useProduct must be used within a ProductPageContext provider");
    return context;
};


/***/ }),

/***/ 82569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useIsFirstRender = function() {
    var isFirst = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsFirstRender);


/***/ }),

/***/ 28397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ STEP; }
/* harmony export */ });
var STEP;
(function(STEP) {
    STEP[STEP["CHOOSE"] = 0] = "CHOOSE";
    STEP[STEP["WRAP"] = 1] = "WRAP";
    STEP[STEP["SEND"] = 2] = "SEND";
    STEP[STEP["PREVIEW"] = 3] = "PREVIEW";
    STEP[STEP["PAY"] = 4] = "PAY";
})(STEP || (STEP = {}));


/***/ }),

/***/ 50252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Us": function() { return /* binding */ ActionType; },
/* harmony export */   "tH": function() { return /* binding */ useCardCustomisationReducer; }
/* harmony export */ });
/* unused harmony export reducer */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




var ActionType;
(function(ActionType) {
    ActionType[ActionType["DisableCardDesignCustomisation"] = 0] = "DisableCardDesignCustomisation";
    ActionType[ActionType["EnableCardDesignCustomisation"] = 1] = "EnableCardDesignCustomisation";
    ActionType[ActionType["ResetCardDesignCustomisation"] = 2] = "ResetCardDesignCustomisation";
    ActionType[ActionType["SelectCardDesign"] = 3] = "SelectCardDesign";
    ActionType[ActionType["CreateCustomThemeDesign"] = 4] = "CreateCustomThemeDesign";
    ActionType[ActionType["SelectCustomCardDesign"] = 5] = "SelectCustomCardDesign";
})(ActionType || (ActionType = {}));
var getInitalState = function(sku) {
    var ref, ref1;
    var emptyState = {
        customCardDesignIsEnabled: false,
        customThemeDesign: null,
        initialCardDesign: null,
        selectedCardDesign: null
    };
    if (!sku) return emptyState;
    if ((ref = sku.themes) === null || ref === void 0 ? void 0 : ref.length) {
        var ref2 = sku.themes[0], uid = ref2.uid, image = ref2.image, cmsImage = ref2.cmsImage;
        var cardDesign = {
            imageUrl: cmsImage ? cmsImage.url : image,
            isTemplate: false,
            uid: uid
        };
        return {
            customCardDesignIsEnabled: false,
            customThemeDesigns: [],
            initialCardDesign: cardDesign,
            selectedCardDesign: cardDesign
        };
    } else if ((ref1 = sku.templates) === null || ref1 === void 0 ? void 0 : ref1.length) {
        var ref3 = sku.templates[0], uid1 = ref3.uid, imagePreview = ref3.imagePreview, cmsImagePreview = ref3.cmsImagePreview;
        var cardDesign1 = {
            imageUrl: cmsImagePreview ? cmsImagePreview.url : imagePreview,
            isTemplate: true,
            uid: uid1
        };
        return {
            customCardDesignIsEnabled: false,
            customThemeDesigns: [],
            initialCardDesign: cardDesign1,
            selectedCardDesign: cardDesign1
        };
    }
    return emptyState;
};
var reducer = function(state, action) {
    var type = action.type, payload = action.payload;
    switch(type){
        case ActionType.DisableCardDesignCustomisation:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                customCardDesignIsEnabled: false
            });
        case ActionType.EnableCardDesignCustomisation:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                customCardDesignIsEnabled: true
            });
        case ActionType.SelectCardDesign:
            {
                var uid = payload.uid, imageUrl = payload.imageUrl;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                    selectedCardDesign: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state.selectedCardDesign), {
                        imageUrl: imageUrl,
                        isTemplate: false,
                        uid: uid
                    })
                });
            }
        case ActionType.SelectCustomCardDesign:
            {
                var uid1 = payload.uid, imageUrl1 = payload.imageUrl;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                    selectedCardDesign: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state.selectedCardDesign), {
                        isTemplate: true,
                        imageUrl: imageUrl1,
                        uid: uid1
                    })
                });
            }
        case ActionType.CreateCustomThemeDesign:
            {
                var customThemeDesign = payload.customThemeDesign, templateUid = payload.templateUid;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                    customThemeDesigns: //remove existing custom theme with same template UID
                    (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(state.customThemeDesigns.filter(function(t) {
                        return t.templateUid !== templateUid;
                    })).concat([
                        (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, customThemeDesign), {
                            templateUid: templateUid
                        }), 
                    ])
                });
            }
        case ActionType.ResetCardDesignCustomisation:
            {
                return {
                    customCardDesignIsEnabled: false,
                    initialCardDesign: state.initialCardDesign,
                    selectedCardDesign: state.initialCardDesign
                };
            }
        default:
            return state;
    }
};
var useCardCustomisationReducer = function(sku) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(reducer, getInitalState(sku));
};


/***/ }),

/***/ 83574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Be": function() { return /* binding */ PaypalStatus; },
/* harmony export */   "Bf": function() { return /* binding */ TabDefaultIndex; },
/* harmony export */   "Us": function() { return /* binding */ ActionType; },
/* harmony export */   "Xw": function() { return /* binding */ CheckoutState; },
/* harmony export */   "gj": function() { return /* binding */ useProductPageReducer; },
/* harmony export */   "u9": function() { return /* binding */ PaymentOptions; }
/* harmony export */ });
/* unused harmony exports PaymentTypes, PurchaseType, PurchaseKind, initialState, reducer */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



var CheckoutState;
(function(CheckoutState) {
    CheckoutState[CheckoutState["NoSelection"] = 0] = "NoSelection";
    CheckoutState[CheckoutState["AddRecipientDetails"] = 1] = "AddRecipientDetails";
    CheckoutState[CheckoutState["Login"] = 2] = "Login";
    CheckoutState[CheckoutState["Register"] = 3] = "Register";
    CheckoutState[CheckoutState["GuestCheckout"] = 4] = "GuestCheckout";
    CheckoutState[CheckoutState["AlreadyLoggedIn"] = 5] = "AlreadyLoggedIn";
    CheckoutState[CheckoutState["FinalisePayment"] = 6] = "FinalisePayment";
    CheckoutState[CheckoutState["Submitting"] = 7] = "Submitting";
})(CheckoutState || (CheckoutState = {}));
var PaypalStatus;
(function(PaypalStatus) {
    PaypalStatus[PaypalStatus["Cancelled"] = 0] = "Cancelled";
    PaypalStatus[PaypalStatus["Processing"] = 1] = "Processing";
    PaypalStatus[PaypalStatus["Idle"] = 2] = "Idle";
})(PaypalStatus || (PaypalStatus = {}));
var PaymentOptions;
(function(PaymentOptions) {
    PaymentOptions[PaymentOptions["Paypal"] = 0] = "Paypal";
    PaymentOptions[PaymentOptions["CreditCard"] = 1] = "CreditCard";
    PaymentOptions[PaymentOptions["ApplePay"] = 2] = "ApplePay";
    PaymentOptions[PaymentOptions["GooglePay"] = 3] = "GooglePay";
})(PaymentOptions || (PaymentOptions = {}));
var PaymentTypes;
(function(PaymentTypes) {
    PaymentTypes[PaymentTypes["NotSelected"] = 0] = "NotSelected";
    PaymentTypes[PaymentTypes["Loading"] = 1] = "Loading";
    PaymentTypes[PaymentTypes["Paypal"] = 2] = "Paypal";
    PaymentTypes[PaymentTypes["CreditCard"] = 3] = "CreditCard";
    PaymentTypes[PaymentTypes["ApplePay"] = 4] = "ApplePay";
    PaymentTypes[PaymentTypes["GooglePay"] = 5] = "GooglePay";
})(PaymentTypes || (PaymentTypes = {}));
var PurchaseType;
(function(PurchaseType) {
    PurchaseType[PurchaseType["Self"] = 0] = "Self";
    PurchaseType[PurchaseType["Friend"] = 1] = "Friend";
    PurchaseType[PurchaseType["TypeNotSelected"] = 2] = "TypeNotSelected";
})(PurchaseType || (PurchaseType = {}));
var PurchaseKind;
(function(PurchaseKind) {
    PurchaseKind[PurchaseKind["User"] = 0] = "User";
    PurchaseKind[PurchaseKind["Guest"] = 1] = "Guest";
    PurchaseKind[PurchaseKind["KindNotSelected"] = 2] = "KindNotSelected";
})(PurchaseKind || (PurchaseKind = {}));
var TabDefaultIndex;
(function(TabDefaultIndex) {
    TabDefaultIndex[TabDefaultIndex["GiftCard"] = 0] = "GiftCard";
    TabDefaultIndex[TabDefaultIndex["Giphy"] = 1] = "Giphy";
    TabDefaultIndex[TabDefaultIndex["Video"] = 2] = "Video";
})(TabDefaultIndex || (TabDefaultIndex = {}));
var initialData = {
    deliveryOption: "Instant",
    giftMedia: null,
    giftTheme: null,
    guestEmail: null,
    guestFirstName: null,
    guestLastName: null,
    message: null,
    giphy: null,
    nzTnC: false,
    paymentMethodId: "creditCard",
    prezzeeEDM: false,
    prezzeeTnC: false,
    promo: null,
    purchaseType: null,
    senderAlias: null,
    value: "",
    recipients: [
        {
            name: "",
            email: null,
            phone: null,
            smsCheckbox: false,
            emailCheckbox: false
        }, 
    ]
};
var initialState = {
    checkoutState: CheckoutState.NoSelection,
    collectBillingAddress: false,
    error: null,
    paymentOptions: [
        PaymentOptions.CreditCard
    ],
    paypal: PaypalStatus.Idle,
    step: 0,
    furthestStep: 0,
    previousStep: null,
    formValues: initialData,
    orderResult: null,
    tabDefaultIndex: TabDefaultIndex.GiftCard,
    defaultGiftCardPage: 0,
    defaultGiphyPage: 0,
    manualCheckoutType: false,
    previewButtonClicked: false
};
var ActionType;
(function(ActionType) {
    ActionType[ActionType["PaypalCancelled"] = 0] = "PaypalCancelled";
    ActionType[ActionType["PaypalIdle"] = 1] = "PaypalIdle";
    ActionType[ActionType["RemoveError"] = 2] = "RemoveError";
    ActionType[ActionType["Reset"] = 3] = "Reset";
    ActionType[ActionType["SetCheckoutState"] = 4] = "SetCheckoutState";
    ActionType[ActionType["SetError"] = 5] = "SetError";
    ActionType[ActionType["SetHasCreditCard"] = 6] = "SetHasCreditCard";
    ActionType[ActionType["SetHasPaypal"] = 7] = "SetHasPaypal";
    ActionType[ActionType["SetHasApplePay"] = 8] = "SetHasApplePay";
    ActionType[ActionType["SetHasGooglePay"] = 9] = "SetHasGooglePay";
    ActionType[ActionType["SetPaymentNotSelected"] = 10] = "SetPaymentNotSelected";
    ActionType[ActionType["SetPaypalNonce"] = 11] = "SetPaypalNonce";
    ActionType[ActionType["SetOrderResult"] = 12] = "SetOrderResult";
    ActionType[ActionType["SetStep"] = 13] = "SetStep";
    ActionType[ActionType["SetPreviousStep"] = 14] = "SetPreviousStep";
    ActionType[ActionType["SetFormValues"] = 15] = "SetFormValues";
    ActionType[ActionType["SetTabDefaultIndex"] = 16] = "SetTabDefaultIndex";
    ActionType[ActionType["SetDefaultGiftCardPage"] = 17] = "SetDefaultGiftCardPage";
    ActionType[ActionType["SetDefaultGiphyPage"] = 18] = "SetDefaultGiphyPage";
    ActionType[ActionType["SetManualCheckout"] = 19] = "SetManualCheckout";
    ActionType[ActionType["SetPreviewButtonClicked"] = 20] = "SetPreviewButtonClicked";
    ActionType[ActionType["SetRecipientToEdit"] = 21] = "SetRecipientToEdit";
    ActionType[ActionType["SetDraftOrder"] = 22] = "SetDraftOrder";
})(ActionType || (ActionType = {}));
var reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    var type = action.type, payload = action.payload;
    switch(type){
        case ActionType.PaypalCancelled:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                paypal: PaypalStatus.Cancelled
            });
        case ActionType.PaypalIdle:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                paypal: PaypalStatus.Idle
            });
        case ActionType.SetOrderResult:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                orderResult: payload
            });
        case ActionType.RemoveError:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                error: null
            });
        case ActionType.Reset:
            return initialState;
        case ActionType.SetCheckoutState:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                checkoutState: payload
            });
        case ActionType.SetError:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                error: payload
            });
        case ActionType.SetHasCreditCard:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                paymentOptions: state.paymentOptions.concat(PaymentOptions.CreditCard)
            });
        case ActionType.SetHasPaypal:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                paymentOptions: state.paymentOptions.concat(PaymentOptions.Paypal)
            });
        case ActionType.SetHasApplePay:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                paymentOptions: state.paymentOptions.concat(PaymentOptions.ApplePay)
            });
        case ActionType.SetHasGooglePay:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                paymentOptions: state.paymentOptions.concat(PaymentOptions.GooglePay)
            });
        case ActionType.SetStep:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                step: payload,
                furthestStep: payload > state.furthestStep ? payload : state.furthestStep
            });
        case ActionType.SetPreviousStep:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                previousStep: payload
            });
        case ActionType.SetFormValues:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                formValues: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state.formValues, payload)
            });
        case ActionType.SetTabDefaultIndex:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                tabDefaultIndex: payload
            });
        case ActionType.SetDefaultGiftCardPage:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                defaultGiftCardPage: payload
            });
        case ActionType.SetDefaultGiphyPage:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                defaultGiphyPage: payload
            });
        case ActionType.SetManualCheckout:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                manualCheckoutType: payload
            });
        case ActionType.SetPreviewButtonClicked:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                previewButtonClicked: true
            });
        case ActionType.SetRecipientToEdit:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                recipientToEdit: payload
            });
        case ActionType.SetDraftOrder:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                draftOrder: payload
            });
        default:
            return state;
    }
};
var useProductPageReducer = function(collectBillingAddress) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(reducer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        collectBillingAddress: collectBillingAddress
    }));
};


/***/ }),

/***/ 69477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AR": function() { return /* binding */ trimToLength; },
/* harmony export */   "Bp": function() { return /* binding */ getWrapSubtitle; },
/* harmony export */   "Bw": function() { return /* binding */ formatValue; },
/* harmony export */   "P$": function() { return /* binding */ makeDraftOrderPayload; },
/* harmony export */   "x1": function() { return /* binding */ getRecipientDetails; }
/* harmony export */ });
/* unused harmony export encodeRecipients */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70655);
/* harmony import */ var spacetime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79402);
/* harmony import */ var js_convert_case__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24417);
/* harmony import */ var bindings_fingerprint__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60270);







var encodeRecipients = function(recipients) {
    return recipients.map(function(param) {
        var name = param.name, email = param.email, phone = param.phone;
        var ref;
        return {
            name: name,
            email: email || undefined,
            phone: phone ? (ref = phone === null || phone === void 0 ? void 0 : phone.toString()) === null || ref === void 0 ? void 0 : ref.trim().replaceAll(/\s/g, "") : undefined
        };
    });
};
/**
 * Maps the product form inputs to the payload for the checkout request.
 * @param input - ProductFormInputs The input from the purchase form
 * @param cardUid - string The uid of the card to use
 * @param purchaseKind - PurchaseKind The kind of purchase (ex. guest or user)
 */ var makeDraftOrderPayload = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(input, cardUid, purchaseKind) {
        var deviceId, basePayload, purchaseType, scheduledDeliveryAt, recipientTimezone, ref, userSelfPayload, ref1, ref2, guestSelfPayload, ref3, ref4, ref5, ref6, ref7, userFriendPayload, ref8, ref9, ref10, ref11, ref12, guestFriendPayload;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,bindings_fingerprint__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)()
                    ];
                case 1:
                    deviceId = _state.sent();
                    basePayload = {
                        status: "draft",
                        stripe_async_payment: true
                    };
                    purchaseType = input.purchaseType;
                    scheduledDeliveryAt = input.scheduledDeliveryAt ? (0,spacetime__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(input.scheduledDeliveryAt).format("iso") : undefined;
                    recipientTimezone = input.scheduledDeliveryAt ? (0,spacetime__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(input.scheduledDeliveryAt).timezone().name : undefined;
                    if (purchaseType === "self" && purchaseKind === "user") {
                        ;
                        userSelfPayload = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, basePayload), {
                            skuUid: cardUid,
                            promoCode: ((ref = input.promo) === null || ref === void 0 ? void 0 : ref.promoCode) || "",
                            themeUid: (input === null || input === void 0 ? void 0 : input.giftCardDesignTab) ? (input === null || input === void 0 ? void 0 : input.customThemeUid) || (input === null || input === void 0 ? void 0 : input.themeUid) || "" : "",
                            value: input === null || input === void 0 ? void 0 : input.value,
                            deviceId: deviceId
                        });
                        return [
                            2,
                            (0,js_convert_case__WEBPACK_IMPORTED_MODULE_0__.snakeKeys)(userSelfPayload)
                        ];
                    } else if (purchaseType === "self" && purchaseKind === "guest") {
                        ;
                        guestSelfPayload = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, basePayload), {
                            value: input === null || input === void 0 ? void 0 : input.value,
                            promoCode: (input === null || input === void 0 ? void 0 : (ref1 = input.promo) === null || ref1 === void 0 ? void 0 : ref1.promoCode) || "",
                            skuUid: cardUid,
                            themeUid: (input === null || input === void 0 ? void 0 : input.giftCardDesignTab) ? (input === null || input === void 0 ? void 0 : input.customThemeUid) || (input === null || input === void 0 ? void 0 : input.themeUid) || "" : "",
                            giftthemeUid: (input === null || input === void 0 ? void 0 : (ref2 = input.giftTheme) === null || ref2 === void 0 ? void 0 : ref2.uid) || "",
                            guestFirstName: (input === null || input === void 0 ? void 0 : input.guestFirstName) || "",
                            guestLastName: (input === null || input === void 0 ? void 0 : input.guestLastName) || "",
                            guestEmail: (input === null || input === void 0 ? void 0 : input.guestEmail) || "",
                            type: "self"
                        });
                        return [
                            2,
                            (0,js_convert_case__WEBPACK_IMPORTED_MODULE_0__.snakeKeys)(guestSelfPayload)
                        ];
                    } else if (purchaseType === "friend" && purchaseKind === "user") {
                        ;
                        userFriendPayload = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, basePayload), {
                            value: input === null || input === void 0 ? void 0 : input.value,
                            senderAlias: (input === null || input === void 0 ? void 0 : input.senderAlias) || undefined,
                            promoCode: (input === null || input === void 0 ? void 0 : (ref3 = input.promo) === null || ref3 === void 0 ? void 0 : ref3.promoCode) || "",
                            skuUid: cardUid,
                            themeUid: (input === null || input === void 0 ? void 0 : input.giftCardDesignTab) ? (input === null || input === void 0 ? void 0 : input.customThemeUid) || (input === null || input === void 0 ? void 0 : input.themeUid) || "" : "",
                            giftthemeUid: (input === null || input === void 0 ? void 0 : input.giftMediaTab) && (input === null || input === void 0 ? void 0 : (ref4 = input.giftTheme) === null || ref4 === void 0 ? void 0 : ref4.uid) || "",
                            giftmediaUid: (input === null || input === void 0 ? void 0 : input.giftMediaTab) && (input === null || input === void 0 ? void 0 : (ref5 = input.giftMedia) === null || ref5 === void 0 ? void 0 : ref5.uid) || undefined,
                            giphyId: (input === null || input === void 0 ? void 0 : input.giftMediaTab) && (input === null || input === void 0 ? void 0 : (ref6 = input.giphy) === null || ref6 === void 0 ? void 0 : ref6.id),
                            giphyUrl: (input === null || input === void 0 ? void 0 : input.giftMediaTab) && (input === null || input === void 0 ? void 0 : (ref7 = input.giphy) === null || ref7 === void 0 ? void 0 : ref7.url),
                            recipients: encodeRecipients((input === null || input === void 0 ? void 0 : input.recipients) || []),
                            scheduledDeliveryAt: scheduledDeliveryAt,
                            recipientTimezone: recipientTimezone,
                            message: (input === null || input === void 0 ? void 0 : input.personaliseMessageTab) && (input === null || input === void 0 ? void 0 : input.message) || "",
                            deviceId: deviceId
                        });
                        return [
                            2,
                            (0,js_convert_case__WEBPACK_IMPORTED_MODULE_0__.snakeKeys)(userFriendPayload)
                        ];
                    } else if (purchaseType === "friend" && purchaseKind === "guest") {
                        ;
                        guestFriendPayload = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, basePayload), {
                            value: input === null || input === void 0 ? void 0 : input.value,
                            senderAlias: (input === null || input === void 0 ? void 0 : input.senderAlias) || undefined,
                            promoCode: (input === null || input === void 0 ? void 0 : (ref8 = input.promo) === null || ref8 === void 0 ? void 0 : ref8.promoCode) || "",
                            skuUid: cardUid,
                            themeUid: (input === null || input === void 0 ? void 0 : input.giftCardDesignTab) ? (input === null || input === void 0 ? void 0 : input.customThemeUid) || (input === null || input === void 0 ? void 0 : input.themeUid) || "" : "",
                            giftthemeUid: (input === null || input === void 0 ? void 0 : input.giftMediaTab) && (input === null || input === void 0 ? void 0 : (ref9 = input.giftTheme) === null || ref9 === void 0 ? void 0 : ref9.uid) || "",
                            giftmediaUid: (input === null || input === void 0 ? void 0 : input.giftMediaTab) && (input === null || input === void 0 ? void 0 : (ref10 = input.giftMedia) === null || ref10 === void 0 ? void 0 : ref10.uid) || undefined,
                            giphyId: (input === null || input === void 0 ? void 0 : input.giftMediaTab) && (input === null || input === void 0 ? void 0 : (ref11 = input.giphy) === null || ref11 === void 0 ? void 0 : ref11.id),
                            giphyUrl: (input === null || input === void 0 ? void 0 : input.giftMediaTab) && (input === null || input === void 0 ? void 0 : (ref12 = input.giphy) === null || ref12 === void 0 ? void 0 : ref12.url),
                            guestFirstName: (input === null || input === void 0 ? void 0 : input.guestFirstName) || "",
                            guestLastName: (input === null || input === void 0 ? void 0 : input.guestLastName) || "",
                            guestEmail: (input === null || input === void 0 ? void 0 : input.guestEmail) || "",
                            type: "friend",
                            recipients: encodeRecipients((input === null || input === void 0 ? void 0 : input.recipients) || []),
                            scheduledDeliveryAt: scheduledDeliveryAt,
                            recipientTimezone: recipientTimezone,
                            message: (input === null || input === void 0 ? void 0 : input.personaliseMessageTab) && (input === null || input === void 0 ? void 0 : input.message) || ""
                        });
                        return [
                            2,
                            (0,js_convert_case__WEBPACK_IMPORTED_MODULE_0__.snakeKeys)(guestFriendPayload)
                        ];
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function makeDraftOrderPayload(input, cardUid, purchaseKind) {
        return _ref.apply(this, arguments);
    };
}();
var formatValue = function(unformattedValue) {
    var valueIncludesCentsRegex = /^\d+.\d{2}$/;
    var valueExcludesCentsRegex = /^\d+$/;
    var includesCents = valueIncludesCentsRegex.test(unformattedValue);
    var excludesCents = valueExcludesCentsRegex.test(unformattedValue);
    if (includesCents) {
        return unformattedValue;
    } else if (excludesCents) {
        return unformattedValue + ".00";
    } else {
        return null;
    }
};
var trimToLength = function(string, length) {
    if (string.length <= length) {
        return string;
    } else {
        return string.substring(0, length);
    }
};
var getRecipientDetails = function(fields, user) {
    if (fields.purchaseType === "self") {
        if (user && (user === null || user === void 0 ? void 0 : user.firstName) && (user === null || user === void 0 ? void 0 : user.lastName)) {
            return "".concat(user.firstName, " ").concat(user.lastName);
        } else if ((fields === null || fields === void 0 ? void 0 : fields.guestFirstName) && (fields === null || fields === void 0 ? void 0 : fields.guestLastName)) {
            return "".concat(fields.guestFirstName, " ").concat(fields.guestLastName);
        } else {
            return "Myself";
        }
    } else if (fields.purchaseType === "friend") {
        var ref, ref1;
        var numberOfRecipients = fields === null || fields === void 0 ? void 0 : (ref = fields.recipients) === null || ref === void 0 ? void 0 : ref.length;
        var subtitle = numberOfRecipients > 1 ? "".concat(numberOfRecipients, " recipients") : ((ref1 = fields === null || fields === void 0 ? void 0 : fields.recipients[0]) === null || ref1 === void 0 ? void 0 : ref1.name) || "";
        return subtitle;
    }
    return undefined;
};
var getWrapSubtitle = function(fields) {
    var wrapTabKeys = [
        "giftMediaTab",
        "giftCardDesignTab",
        "personaliseMessageTab"
    ];
    var tabsSelected = 0;
    wrapTabKeys.forEach(function(key) {
        (fields === null || fields === void 0 ? void 0 : fields[key]) && tabsSelected++;
    });
    switch(tabsSelected){
        case 0:
            return "";
        case 1:
            return "One selected";
        case 2:
            return "Two selected";
        case 3:
            return "All selected";
        default:
            return "";
    }
};


/***/ }),

/***/ 50857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QX": function() { return /* binding */ generateUniqueUserId; }
/* harmony export */ });
/* unused harmony exports getGiftTheme, isEmptyValue, getSegmentCompletedOrderProduct, BuyFor, getCheckoutStartedProduct, sendSegmentCheckoutStarted, customThemeImageUrlExists, setSelectedThemeData, getProductFromCard, sendSegmentCompletedOrder, useProductPageSegment */
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25934);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92592);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _bindings_Segment_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73840);
/* harmony import */ var _FormHelpers_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43243);
// Generated by ReScript, PLEASE EDIT WITH CARE











function getGiftTheme(giftThemeData, giftThemeUid) {
    return Belt_Option.mapWithDefault(giftThemeData, "", function(t) {
        var theme = Belt_Array.getBy(t.giftThemes, function(s) {
            return s.uid === FormHelpers.getValue(giftThemeUid);
        });
        return Belt_Option.mapWithDefault(theme, "", function(theme) {
            return theme.title;
        });
    });
}
function isEmptyValue(value) {
    if (Caml_obj.equal(value, "")) {
        return true;
    } else {
        return value === null;
    }
}
function getSegmentCompletedOrderProduct(formValues, themes, card, href) {
    var giftTheme = getGiftTheme(themes, formValues.giftThemeUid);
    var doesThemeExistInTemplates = Belt_Array.some(card.themes, function(x) {
        return x.uid === formValues.themeUid;
    });
    var isCustomSkuThemeDesign = doesThemeExistInTemplates ? "false" : "true";
    return Object.assign(Segment.cardToProduct(card), {
        url: href,
        gift_theme: giftTheme,
        price: Belt_Int.fromString(formValues.value),
        sku_theme_design_uid: formValues.themeUid,
        is_custom_sku_theme_design: isCustomSkuThemeDesign
    });
}
function getSegmentBuyForKey(state) {
    var match = state.senderAlias;
    if (typeof match !== "number") {
        return "anonymousgift";
    }
    switch(match){
        case /* Myself */ 0:
            return "myself";
        case /* Gift */ 1:
            return "gift";
        case /* SenderAliasNotSelected */ 2:
            return "";
    }
}
function makeSegmentData(state, purchaseInstanceId) {
    return {
        step_name: "PCbuyingFlowSelectSelfPurchaseOrGift",
        buy_for: getSegmentBuyForKey(state),
        purchase_instance_id: purchaseInstanceId,
        step: 1
    };
}
function callbackIfTypeSelected(state, segmentCallback, purchaseInstanceId) {
    var match = state.senderAlias;
    if (typeof match === "number" && match >= 2) {
        return false;
    }
    var trackingObj = makeSegmentData(state, purchaseInstanceId);
    _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_3__._1(segmentCallback, trackingObj);
    return true;
}
var BuyFor = {
    getSegmentBuyForKey: getSegmentBuyForKey,
    makeSegmentData: makeSegmentData,
    callbackIfTypeSelected: callbackIfTypeSelected
};
function getCheckoutStartedProduct(card, href, state) {
    return Object.assign(Segment.cardToProduct(card), {
        url: href,
        price: Belt_Int.fromString(Belt_Option.getWithDefault(state.purchasePrice, "0"))
    });
}
function sendSegmentCheckoutStarted(product, value, callback, purchaseInstanceId) {
    Curry._1(callback, {
        affiliation: "consumer",
        total: Belt_Int.fromString(Belt_Option.getWithDefault(value == null ? undefined : Caml_option.some(value), "0")),
        currency: "AUD",
        purchase_instance_id: purchaseInstanceId,
        products: [
            product
        ]
    });
}
function customThemeImageUrlExists(imageUrl) {
    return Belt_Option.mapWithDefault(imageUrl == null ? undefined : Caml_option.some(imageUrl), "false", function(image) {
        if (image === "") {
            return "false";
        } else {
            return "true";
        }
    });
}
function setSelectedThemeData(product, card, themeUid, customThemeUid, customThemeImageUrl) {
    var defaultTheme = Belt_Option.mapWithDefault(themeUid == null ? undefined : Caml_option.some(themeUid), undefined, function(themeUid) {
        return Belt_Array.getBy(card.themes, function(theme) {
            return theme.uid === themeUid;
        });
    });
    if (defaultTheme !== undefined) {
        return Object.assign(product, {
            image_uid: defaultTheme.uid,
            image_url: defaultTheme.image,
            image_card_upload: "false"
        });
    }
    var imageUid = Belt_Option.mapWithDefault(customThemeUid == null ? undefined : Caml_option.some(customThemeUid), "", function(themeUid) {
        return themeUid;
    });
    var imageUrl = Belt_Option.mapWithDefault(customThemeImageUrl == null ? undefined : Caml_option.some(customThemeImageUrl), "", function(themeImageUrl) {
        return themeImageUrl;
    });
    return Object.assign(product, {
        image_uid: imageUid,
        image_url: imageUrl,
        image_card_upload: customThemeImageUrlExists(customThemeImageUrl)
    });
}
function getProductFromCard(formValues, themes, card, href) {
    var giftTheme = getGiftTheme(themes, formValues.giftThemeUid);
    var doesThemeExistInTemplates = Belt_Array.some(card.themes, function(x) {
        return x.uid === formValues.themeUid;
    });
    var isCustomSkuThemeDesign = doesThemeExistInTemplates ? "false" : "true";
    return Object.assign(Segment.cardToProduct(card), {
        url: href,
        gift_theme: giftTheme,
        price: Belt_Int.fromString(formValues.value),
        sku_theme_design_uid: formValues.themeUid,
        is_custom_sku_theme_design: isCustomSkuThemeDesign
    });
}
function sendSegmentCompletedOrder(state, formValues, orderResultUid, orderResultTotal, product, callback, purchaseInstanceId) {
    var coupon = Belt_Option.mapWithDefault(Caml_option.nullable_to_opt(formValues.promo), "", function(p) {
        return p.promoCode;
    });
    var buyFor = getSegmentBuyForKey(state);
    var giftMediaUid = formValues.giftMediaUid;
    var videoMessage = giftMediaUid == null ? "false" : "true";
    var scheduledDeliveryAt = formValues.scheduledDeliveryAt;
    var deliveryMethod = scheduledDeliveryAt == null ? "now" : "schedule";
    var reciContactShared = Belt_Option.mapWithDefault(Caml_option.nullable_to_opt(formValues.phone), "false", function(phone) {
        if (phone.number !== "") {
            return "true";
        } else {
            return "false";
        }
    });
    var guestEmailCtx = Belt_Option.mapWithDefault(Caml_option.nullable_to_opt(formValues.guestEmail), {}, function(p) {
        return {
            traits: {
                email: p
            }
        };
    });
    var ttclid = localStorage.getItem("ttclid");
    var ttclid$1 = ttclid == null ? undefined : Caml_option.some(ttclid);
    localStorage.removeItem("ttclid");
    var defaultProps = {
        coupon: coupon,
        buy_for: buyFor,
        video_message: videoMessage,
        gift_theme_uid: formValues.giftThemeUid,
        delivery_method: deliveryMethod,
        recipient_phonedetail_fields: reciContactShared,
        purchase_instance_id: purchaseInstanceId,
        order_number: orderResultUid,
        affiliation: "consumer",
        total: Belt_Int.fromString(orderResultTotal),
        currency: "AUD",
        products: [
            product
        ],
        server_region: "AU",
        store: "consumer"
    };
    var props = Js_option.isNone(ttclid$1) || ttclid$1 === "" ? defaultProps : Object.assign(defaultProps, {
        ttclid: ttclid$1
    });
    return Curry._2(callback, props, guestEmailCtx);
}
function generateUniqueUserId(param) {
    var timeStamp = Date.now().toString();
    var uuid = uuid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z();
    return timeStamp.concat(uuid);
}
function useProductPageSegment(state, card, form, step1Callback, purchaseInstanceId, preselectedValue) {
    var value = Curry._2(form.watch, "value", preselectedValue);
    var prevValue = React.useRef(value);
    var themeUid = Curry._2(form.watch, "themeUid", "");
    var customThemeUid = Curry._2(form.watch, "customThemeUid", "");
    var customThemeImageUrl = Curry._2(form.watch, "customThemeImageUrl", "");
    var sendSegmentProductAdded = function sendSegmentProductAdded(card) {
        Segment.productAdded(setSelectedThemeData(Object.assign(Segment.cardToProductNoImageUrl(card), {
            url: document.location.href,
            purchase_instance_id: purchaseInstanceId,
            price: Belt_Int.fromString(Belt_Option.getWithDefault(value == null ? undefined : Caml_option.some(value), "0")),
            store: "consumer"
        }), card, themeUid, customThemeUid, customThemeImageUrl));
    };
    React.useEffect(function() {
        setTimeout(function(param) {
            if (preselectedValue !== "") {
                return sendSegmentProductAdded(card);
            }
        }, 700);
    }, []);
    React.useEffect(function() {
        if (state.senderAlias !== /* SenderAliasNotSelected */ 2) {
            var product = getCheckoutStartedProduct(card, document.location.href, state);
            sendSegmentCheckoutStarted(product, value, Segment.checkoutStarted, purchaseInstanceId);
            Curry._3(step1Callback, state, Segment.checkoutStepCompleted, purchaseInstanceId);
        }
    }, [
        state.senderAlias
    ]);
    React.useEffect(function() {
        var match = state.orderResult;
        var orderSent = match !== undefined;
        if (!isEmptyValue(prevValue.current) && Caml_obj.notequal(value, prevValue.current) && !orderSent) {
            Segment.productRemoved(Object.assign(Segment.cardToProduct(card), {
                url: document.location.href,
                purchase_instance_id: purchaseInstanceId,
                price: Belt_Int.fromString(Belt_Option.getWithDefault(Caml_option.nullable_to_opt(prevValue.current), "0"))
            }));
        }
        if (!isEmptyValue(value) && Caml_obj.notequal(prevValue.current, value)) {
            sendSegmentProductAdded(card);
        }
        prevValue.current = value;
    }, [
        value
    ]);
}
 /* uuid Not a pure module */ 


/***/ })

}]);